function PlanD({ ...props }) {
	return (
		<g {...props} id="unit-d">
			<g id="furniture">
				<polyline
					points="697.5 849.93 692.23 849.93 692.23 847.26 697.5 847.26 697.5 849.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.12 613.21 764.12 844.6 706.07 844.6 706.07 613.21 764.12 613.21"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="460.85"
					y1="665.77"
					x2="460.85"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="521.15"
					x2="424.57"
					y2="526.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="530.44"
					x2="424.57"
					y2="536.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="539.73"
					x2="424.57"
					y2="545.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="549.02"
					x2="424.57"
					y2="554.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="558.31"
					x2="424.57"
					y2="564.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="567.6"
					x2="424.57"
					y2="573.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="576.88"
					x2="424.57"
					y2="582.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="586.17"
					x2="424.57"
					y2="591.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="595.46"
					x2="424.57"
					y2="601.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="604.75"
					x2="424.57"
					y2="610.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="614.04"
					x2="424.57"
					y2="619.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.57"
					y1="623.32"
					x2="424.57"
					y2="629.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.24"
					y1="665.77"
					x2="449.05"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.53"
					y1="665.77"
					x2="458.43"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="665.77"
					x2="458.43"
					y2="660.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="657"
					x2="458.43"
					y2="651.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="647.71"
					x2="458.43"
					y2="641.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="638.42"
					x2="458.43"
					y2="632.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="629.13"
					x2="458.43"
					y2="623.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="619.84"
					x2="458.43"
					y2="614.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="610.55"
					x2="458.43"
					y2="604.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="601.26"
					x2="458.43"
					y2="595.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="591.98"
					x2="458.43"
					y2="586.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="582.69"
					x2="458.43"
					y2="576.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="573.4"
					x2="458.43"
					y2="567.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="564.11"
					x2="458.43"
					y2="558.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="554.82"
					x2="458.43"
					y2="549.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="545.54"
					x2="458.43"
					y2="539.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="536.25"
					x2="458.43"
					y2="530.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="526.96"
					x2="458.43"
					y2="521.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="517.67"
					x2="458.43"
					y2="511.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="508.38"
					x2="458.43"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.43"
					y1="503.09"
					x2="452.53"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.05"
					y1="503.09"
					x2="443.24"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="439.76"
					y1="503.09"
					x2="433.95"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.19"
					y1="629.49"
					x2="270.03"
					y2="629.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.19"
					y1="503.09"
					x2="376.19"
					y2="629.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.28"
					y1="665.77"
					x2="358.09"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.57"
					y1="665.77"
					x2="367.38"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.86"
					y1="665.77"
					x2="376.66"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.15"
					y1="665.77"
					x2="385.95"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.43"
					y1="665.77"
					x2="395.24"
					y2="665.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="629.13"
					x2="412.47"
					y2="623.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="619.84"
					x2="412.47"
					y2="614.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="610.55"
					x2="412.47"
					y2="604.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="601.26"
					x2="412.47"
					y2="595.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="591.98"
					x2="412.47"
					y2="586.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="582.69"
					x2="412.47"
					y2="576.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="573.4"
					x2="412.47"
					y2="567.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="564.11"
					x2="412.47"
					y2="558.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="554.82"
					x2="412.47"
					y2="549.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="545.54"
					x2="412.47"
					y2="539.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="536.25"
					x2="412.47"
					y2="530.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="412.47"
					y1="526.96"
					x2="412.47"
					y2="521.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="393.8"
					y1="503.09"
					x2="387.99"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.51"
					y1="503.09"
					x2="378.61"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="503.09"
					x2="378.61"
					y2="505.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="508.87"
					x2="378.61"
					y2="514.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="518.15"
					x2="378.61"
					y2="523.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="527.44"
					x2="378.61"
					y2="533.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="536.73"
					x2="378.61"
					y2="542.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="546.02"
					x2="378.61"
					y2="551.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="555.31"
					x2="378.61"
					y2="561.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="564.6"
					x2="378.61"
					y2="570.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="573.88"
					x2="378.61"
					y2="579.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="583.17"
					x2="378.61"
					y2="588.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="592.46"
					x2="378.61"
					y2="598.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="601.75"
					x2="378.61"
					y2="607.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="611.04"
					x2="378.61"
					y2="616.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="620.33"
					x2="378.61"
					y2="626.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="629.62"
					x2="378.61"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="378.61"
					y1="631.91"
					x2="372.5"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.02"
					y1="631.91"
					x2="363.21"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.73"
					y1="631.91"
					x2="353.92"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.44"
					y1="631.91"
					x2="344.64"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.15"
					y1="631.91"
					x2="335.35"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.87"
					y1="631.91"
					x2="326.06"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="322.58"
					y1="631.91"
					x2="316.77"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.29"
					y1="631.91"
					x2="307.48"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304"
					y1="631.91"
					x2="298.19"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.71"
					y1="631.91"
					x2="288.91"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.42"
					y1="631.91"
					x2="279.62"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.14"
					y1="631.91"
					x2="270.03"
					y2="631.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.03"
					y1="631.91"
					x2="270.03"
					y2="637.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.03"
					y1="641.29"
					x2="270.03"
					y2="647.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.03"
					y1="650.58"
					x2="270.03"
					y2="656.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="718.68 494.53 778.44 494.53 778.44 554.29 718.68 554.29 718.68 494.53"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="368.73 63.53 368.61 65.95 269.79 60.96 269.91 58.54 368.73 63.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="368.73"
					y1="63.53"
					x2="368.61"
					y2="65.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.61"
					y1="65.95"
					x2="269.79"
					y2="60.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.79"
					y1="60.96"
					x2="269.91"
					y2="58.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.91"
					y1="58.54"
					x2="368.73"
					y2="63.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="417.96 65.06 377.38 63.01 377.12 68.24 417.7 70.29 417.96 65.06"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="375.51 62.44 419.88 64.68 419.86 65.16 375.48 62.92 375.51 62.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="375.51"
					y1="62.44"
					x2="419.88"
					y2="64.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.88"
					y1="64.68"
					x2="419.86"
					y2="65.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.86"
					y1="65.16"
					x2="375.48"
					y2="62.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.48"
					y1="62.92"
					x2="375.51"
					y2="62.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.7"
					y1="70.29"
					x2="377.12"
					y2="68.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.38"
					y1="63.01"
					x2="417.96"
					y2="65.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="421.97 70.51 417.7 70.29 417.96 65.06 422.24 65.28 421.97 70.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="421.97"
					y1="70.51"
					x2="417.7"
					y2="70.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.7"
					y1="70.29"
					x2="417.96"
					y2="65.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.96"
					y1="65.06"
					x2="422.24"
					y2="65.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.24"
					y1="65.28"
					x2="421.97"
					y2="70.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="373.1 62.8 377.38 63.01 377.12 68.24 372.84 68.03 373.1 62.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="373.1"
					y1="62.8"
					x2="377.38"
					y2="63.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.38"
					y1="63.01"
					x2="377.12"
					y2="68.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.12"
					y1="68.24"
					x2="372.84"
					y2="68.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.84"
					y1="68.03"
					x2="373.1"
					y2="62.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="417.91"
					y1="66.01"
					x2="377.33"
					y2="63.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="423.9 70.13 422 70.03 422.24 65.28 419.86 65.16 419.88 64.68 424.16 64.9 423.9 70.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="423.9"
					y1="70.13"
					x2="422"
					y2="70.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422"
					y1="70.03"
					x2="422.24"
					y2="65.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="422.24"
					y1="65.28"
					x2="419.86"
					y2="65.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.86"
					y1="65.16"
					x2="419.88"
					y2="64.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.88"
					y1="64.68"
					x2="424.16"
					y2="64.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.16"
					y1="64.9"
					x2="423.9"
					y2="70.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="371.22 62.22 375.51 62.44 375.48 62.92 373.1 62.8 372.86 67.55 370.96 67.46 371.22 62.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="371.22"
					y1="62.22"
					x2="375.51"
					y2="62.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.51"
					y1="62.44"
					x2="375.48"
					y2="62.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.48"
					y1="62.92"
					x2="373.1"
					y2="62.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.1"
					y1="62.8"
					x2="372.86"
					y2="67.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.86"
					y1="67.55"
					x2="370.96"
					y2="67.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.96"
					y1="67.46"
					x2="371.22"
					y2="62.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.49 58.42 272.32 58.66 271.59 73.16 266.76 72.91 267.49 58.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="272.32"
					y1="58.66"
					x2="267.49"
					y2="58.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.59"
					y1="73.16"
					x2="272.32"
					y2="58.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.76"
					y1="72.91"
					x2="271.59"
					y2="73.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.49"
					y1="58.42"
					x2="266.76"
					y2="72.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="366.32 63.41 371.15 63.65 370.42 78.15 365.59 77.9 366.32 63.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="371.15"
					y1="63.65"
					x2="366.32"
					y2="63.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.42"
					y1="78.15"
					x2="371.15"
					y2="63.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.59"
					y1="77.9"
					x2="370.42"
					y2="78.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.32"
					y1="63.41"
					x2="365.59"
					y2="77.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="428.93 66.57 428.19 81.06 423.36 80.82 424.09 66.32 428.93 66.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="428.19"
					y1="81.06"
					x2="428.93"
					y2="66.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.36"
					y1="80.82"
					x2="428.19"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="424.09"
					y1="66.32"
					x2="423.36"
					y2="80.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.93"
					y1="66.57"
					x2="424.09"
					y2="66.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="664.99 78.48 664.87 80.9 534.22 74.31 534.34 71.89 664.99 78.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="664.99"
					y1="78.48"
					x2="664.87"
					y2="80.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.87"
					y1="80.9"
					x2="534.22"
					y2="74.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.22"
					y1="74.31"
					x2="534.34"
					y2="71.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.34"
					y1="71.89"
					x2="664.99"
					y2="78.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="710.65 79.84 673.64 77.97 673.37 83.2 710.39 85.07 710.65 79.84"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="671.76 77.4 712.58 79.46 712.55 79.93 671.73 77.87 671.76 77.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="671.76"
					y1="77.4"
					x2="712.58"
					y2="79.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.58"
					y1="79.46"
					x2="712.55"
					y2="79.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.55"
					y1="79.93"
					x2="671.73"
					y2="77.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.73"
					y1="77.87"
					x2="671.76"
					y2="77.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.39"
					y1="85.07"
					x2="673.37"
					y2="83.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.64"
					y1="77.97"
					x2="710.65"
					y2="79.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="714.66 85.28 710.39 85.07 710.65 79.84 714.93 80.05 714.66 85.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="714.66"
					y1="85.28"
					x2="710.39"
					y2="85.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.39"
					y1="85.07"
					x2="710.65"
					y2="79.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.65"
					y1="79.84"
					x2="714.93"
					y2="80.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.93"
					y1="80.05"
					x2="714.66"
					y2="85.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="669.36 77.75 673.64 77.97 673.37 83.2 669.09 82.98 669.36 77.75"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="669.36"
					y1="77.75"
					x2="673.64"
					y2="77.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.64"
					y1="77.97"
					x2="673.37"
					y2="83.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="673.37"
					y1="83.2"
					x2="669.09"
					y2="82.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.09"
					y1="82.98"
					x2="669.36"
					y2="77.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="710.6"
					y1="80.79"
					x2="673.59"
					y2="78.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="716.59 84.9 714.69 84.81 714.93 80.05 712.55 79.93 712.58 79.46 716.85 79.67 716.59 84.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="716.59"
					y1="84.9"
					x2="714.69"
					y2="84.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.69"
					y1="84.81"
					x2="714.93"
					y2="80.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.93"
					y1="80.05"
					x2="712.55"
					y2="79.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.55"
					y1="79.93"
					x2="712.58"
					y2="79.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="712.58"
					y1="79.46"
					x2="716.85"
					y2="79.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.85"
					y1="79.67"
					x2="716.59"
					y2="84.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="667.48 77.18 671.76 77.4 671.73 77.87 669.36 77.75 669.12 82.51 667.21 82.41 667.48 77.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.48"
					y1="77.18"
					x2="671.76"
					y2="77.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.76"
					y1="77.4"
					x2="671.73"
					y2="77.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="671.73"
					y1="77.87"
					x2="669.36"
					y2="77.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.36"
					y1="77.75"
					x2="669.12"
					y2="82.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.12"
					y1="82.51"
					x2="667.21"
					y2="82.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.21"
					y1="82.41"
					x2="667.48"
					y2="77.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="662.58 78.36 667.41 78.61 666.68 93.1 661.84 92.86 662.58 78.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="667.41"
					y1="78.61"
					x2="662.58"
					y2="78.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.68"
					y1="93.1"
					x2="667.41"
					y2="78.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="661.84"
					y1="92.86"
					x2="666.68"
					y2="93.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.58"
					y1="78.36"
					x2="661.84"
					y2="92.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="721.61 81.34 720.88 95.84 716.05 95.59 716.78 81.1 721.61 81.34"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="720.88"
					y1="95.84"
					x2="721.61"
					y2="81.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.05"
					y1="95.59"
					x2="720.88"
					y2="95.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.78"
					y1="81.1"
					x2="716.05"
					y2="95.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.61"
					y1="81.34"
					x2="716.78"
					y2="81.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="531.92 71.77 536.75 72.01 536.02 86.51 531.19 86.26 531.92 71.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="536.75"
					y1="72.01"
					x2="531.92"
					y2="71.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.02"
					y1="86.51"
					x2="536.75"
					y2="72.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.19"
					y1="86.26"
					x2="536.02"
					y2="86.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.92"
					y1="71.77"
					x2="531.19"
					y2="86.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="844.6"
					x2="784.04"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.12"
					y1="844.6"
					x2="764.12"
					y2="825.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="764.12"
					y1="613.21"
					x2="764.12"
					y2="825.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="613.21"
					x2="764.12"
					y2="613.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="613.21"
					x2="704.72"
					y2="593.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="563.99"
					x2="724.07"
					y2="563.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="784.04"
					y1="563.99"
					x2="724.07"
					y2="563.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="784.04"
					y1="485.55"
					x2="784.04"
					y2="563.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="721.86"
					y1="76.51"
					x2="720.88"
					y2="95.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.62"
					y1="751.88"
					x2="351.62"
					y2="732.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.62"
					y1="677.87"
					x2="351.62"
					y2="685.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.62"
					y1="732.53"
					x2="351.62"
					y2="685.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="331.38"
					y1="751.88"
					x2="351.62"
					y2="751.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="331.38"
					y1="904.02"
					x2="331.38"
					y2="751.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.53"
					y1="934.01"
					x2="515.9"
					y2="933.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="516.99"
					y2="914.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="519.53"
					y2="934.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="611.3"
					y1="939.18"
					x2="614.92"
					y2="939.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="616.01"
					y2="920.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="611.3"
					y2="939.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="610.02 940.32 614.85 940.59 614.92 939.38 610.09 939.11 610.02 940.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="611.18 919.79 616.01 920.06 616.08 918.85 611.25 918.58 611.18 919.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="521.89 913.54 517.06 913.27 516.99 914.48 521.82 914.75 521.89 913.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="610.02"
					y1="940.32"
					x2="614.85"
					y2="940.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.85"
					y1="940.59"
					x2="614.92"
					y2="939.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="614.92"
					y1="939.38"
					x2="610.09"
					y2="939.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.09"
					y1="939.11"
					x2="610.02"
					y2="940.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.74"
					y1="934.07"
					x2="515.9"
					y2="933.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.67"
					y1="935.28"
					x2="520.74"
					y2="934.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.18"
					y1="919.79"
					x2="616.01"
					y2="920.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.01"
					y1="920.06"
					x2="616.08"
					y2="918.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="616.08"
					y1="918.85"
					x2="611.25"
					y2="918.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.25"
					y1="918.58"
					x2="611.18"
					y2="919.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.89"
					y1="913.54"
					x2="517.06"
					y2="913.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="517.06"
					y1="913.27"
					x2="516.99"
					y2="914.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.99"
					y1="914.48"
					x2="521.82"
					y2="914.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.82"
					y1="914.75"
					x2="521.89"
					y2="913.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="608.88 939.04 610.69 939.14 611.78 919.82 609.97 919.72 608.88 939.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="520.13 934.04 521.94 934.14 523.03 914.82 521.22 914.72 520.13 934.04"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="587.97 856.81 523.03 914.82 525.85 917.98 590.79 859.97 587.97 856.81"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="611.78"
					y1="919.82"
					x2="612.39"
					y2="919.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.69"
					y1="939.14"
					x2="611.3"
					y2="939.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="611.3"
					y2="939.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="914.72"
					x2="520.61"
					y2="914.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.13"
					y1="934.04"
					x2="519.53"
					y2="934.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="519.53"
					y2="934.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="608.88"
					y1="939.04"
					x2="609.97"
					y2="919.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.97"
					y1="919.72"
					x2="611.78"
					y2="919.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.78"
					y1="919.82"
					x2="610.69"
					y2="939.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.69"
					y1="939.14"
					x2="608.88"
					y2="939.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="520.13"
					y1="934.04"
					x2="521.22"
					y2="914.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.22"
					y1="914.72"
					x2="523.03"
					y2="914.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.03"
					y1="914.82"
					x2="521.94"
					y2="934.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="521.94"
					y1="934.14"
					x2="520.13"
					y2="934.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.97"
					y1="856.81"
					x2="590.79"
					y2="859.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="590.79"
					y1="859.97"
					x2="525.85"
					y2="917.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="525.85"
					y1="917.98"
					x2="523.03"
					y2="914.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="523.03"
					y1="914.82"
					x2="587.97"
					y2="856.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="611.3"
					y2="939.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="611.3"
					y2="939.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="616.01"
					y2="920.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="612.39"
					y1="919.85"
					x2="616.01"
					y2="920.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="611.3"
					y1="939.18"
					x2="614.92"
					y2="939.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="611.3"
					y1="939.18"
					x2="614.92"
					y2="939.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="519.53"
					y2="934.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="519.53"
					y2="934.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="516.99"
					y2="914.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="520.61"
					y1="914.68"
					x2="516.99"
					y2="914.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.53"
					y1="934.01"
					x2="515.9"
					y2="933.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="519.53"
					y1="934.01"
					x2="515.9"
					y2="933.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="490.82"
					x2="716.81"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="704.72"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="716.81"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="558.55"
					x2="716.81"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="704.72"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="563.99"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="490.82"
					x2="716.81"
					y2="485.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="704.72"
					y2="563.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="718.02 557.34 716.81 557.34 716.81 562.18 718.02 562.18 718.02 557.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="716.81 492.03 718.02 492.03 718.02 487.19 716.81 487.19 716.81 492.03"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="704.72 557.34 703.51 557.34 703.51 562.18 704.72 562.18 704.72 557.34"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="703.51 492.03 704.72 492.03 704.72 487.19 703.51 487.19 703.51 492.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="718.02"
					y1="557.34"
					x2="718.02"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.02"
					y1="562.18"
					x2="716.81"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="562.18"
					x2="716.81"
					y2="557.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="557.34"
					x2="718.02"
					y2="557.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="492.03"
					x2="716.81"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="487.19"
					x2="718.02"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.02"
					y1="487.19"
					x2="718.02"
					y2="492.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.02"
					y1="492.03"
					x2="716.81"
					y2="492.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="557.34"
					x2="704.72"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="562.18"
					x2="703.51"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.51"
					y1="562.18"
					x2="703.51"
					y2="557.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.51"
					y1="557.34"
					x2="704.72"
					y2="557.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.51"
					y1="492.03"
					x2="703.51"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.51"
					y1="487.19"
					x2="704.72"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="487.19"
					x2="704.72"
					y2="492.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="492.03"
					x2="703.51"
					y2="492.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="716.81 556.13 704.72 556.13 704.72 557.95 716.81 557.95 716.81 556.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="716.81 491.43 704.72 491.43 704.72 493.24 716.81 493.24 716.81 491.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="660.25 537.71 663.24 540.71 707.71 496.24 704.72 493.24 660.25 537.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="704.72"
					y1="557.95"
					x2="704.72"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="557.95"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="491.43"
					x2="704.72"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="491.43"
					x2="716.81"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="716.81"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="556.13"
					x2="704.72"
					y2="556.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="556.13"
					x2="704.72"
					y2="557.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="557.95"
					x2="716.81"
					y2="557.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="557.95"
					x2="716.81"
					y2="556.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="491.43"
					x2="704.72"
					y2="491.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="491.43"
					x2="704.72"
					y2="493.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="493.24"
					x2="716.81"
					y2="493.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.81"
					y1="493.24"
					x2="716.81"
					y2="491.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.25"
					y1="537.71"
					x2="663.24"
					y2="540.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.24"
					y1="540.71"
					x2="707.71"
					y2="496.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.71"
					y1="496.24"
					x2="704.72"
					y2="493.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="493.24"
					x2="660.25"
					y2="537.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="716.81"
					y2="558.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="704.72"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="558.55"
					x2="704.72"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="558.55"
					x2="716.81"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="558.55"
					x2="716.81"
					y2="562.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="716.81"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="716.81"
					y2="490.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="704.72"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="704.72"
					y1="490.82"
					x2="704.72"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="490.82"
					x2="716.81"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="490.82"
					x2="716.81"
					y2="487.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="716.81"
					y1="485.55"
					x2="784.04"
					y2="485.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="896.33"
					x2="504.65"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="492.56"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="504.65"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="804.41"
					x2="504.65"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="492.56"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="504.65"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="651.54"
					x2="492.56"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="651.54"
					x2="492.56"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="504.65"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="494.98"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="510.04"
					x2="492.56"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="510.04"
					x2="492.56"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="504.65"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="494.98"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="483.37"
					x2="504.65"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="492.56"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="391.45"
					x2="504.65"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="492.56"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="503.09"
					x2="492.56"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="505.86 805.62 505.86 800.78 504.65 800.78 504.65 805.62 505.86 805.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.65 895.12 504.65 899.95 505.86 899.95 505.86 895.12 504.65 895.12"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="492.56 805.62 492.56 800.78 491.35 800.78 491.35 805.62 492.56 805.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="491.35 895.12 491.35 899.95 492.56 899.95 492.56 895.12 491.35 895.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="505.86"
					y1="805.62"
					x2="505.86"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.86"
					y1="800.78"
					x2="504.65"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="800.78"
					x2="504.65"
					y2="805.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="805.62"
					x2="505.86"
					y2="805.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="895.12"
					x2="504.65"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="899.95"
					x2="505.86"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.86"
					y1="899.95"
					x2="505.86"
					y2="895.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.86"
					y1="895.12"
					x2="504.65"
					y2="895.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="805.62"
					x2="492.56"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="800.78"
					x2="491.35"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="800.78"
					x2="491.35"
					y2="805.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="805.62"
					x2="492.56"
					y2="805.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="895.12"
					x2="491.35"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="899.95"
					x2="492.56"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="899.95"
					x2="492.56"
					y2="895.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="895.12"
					x2="491.35"
					y2="895.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="504.65 806.83 504.65 805.01 492.56 805.01 492.56 806.83 504.65 806.83"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.65 895.72 504.65 893.9 492.56 893.9 492.56 895.72 504.65 895.72"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="430.98 832.33 492.56 893.9 495.55 890.91 433.98 829.34 430.98 832.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="492.56"
					y1="805.01"
					x2="492.56"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="805.01"
					x2="504.65"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="504.65"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="895.72"
					x2="492.56"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="895.72"
					x2="504.65"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="504.65"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="806.83"
					x2="492.56"
					y2="806.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="806.83"
					x2="492.56"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="805.01"
					x2="504.65"
					y2="805.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="805.01"
					x2="504.65"
					y2="806.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="895.72"
					x2="492.56"
					y2="895.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="895.72"
					x2="492.56"
					y2="893.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="893.9"
					x2="504.65"
					y2="893.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="893.9"
					x2="504.65"
					y2="895.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.98"
					y1="832.33"
					x2="433.98"
					y2="829.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.98"
					y1="829.34"
					x2="495.55"
					y2="890.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.55"
					y1="890.91"
					x2="492.56"
					y2="893.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="893.9"
					x2="430.98"
					y2="832.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="504.65"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="504.65"
					y2="804.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="492.56"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="804.41"
					x2="492.56"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="804.41"
					x2="504.65"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="804.41"
					x2="504.65"
					y2="800.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="504.65"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="504.65"
					y2="896.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="492.56"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="896.33"
					x2="492.56"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="896.33"
					x2="504.65"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="896.33"
					x2="504.65"
					y2="899.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="494.98 511.85 494.98 510.64 492.56 510.64 492.56 511.85 494.98 511.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="491.35 511.85 492.56 511.85 492.56 507.01 491.35 507.01 491.35 511.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="494.98 650.93 494.98 649.73 492.56 649.73 492.56 650.93 494.98 650.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="492.56 649.73 491.35 649.73 491.35 654.56 492.56 654.56 492.56 649.73"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.65 511.85 507.67 511.85 507.67 507.01 504.65 507.01 504.65 511.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="507.67 649.73 504.65 649.73 504.65 654.56 507.67 654.56 507.67 649.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="494.98"
					y1="511.85"
					x2="492.56"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="511.85"
					x2="492.56"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="510.64"
					x2="494.98"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="510.64"
					x2="494.98"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="511.85"
					x2="491.35"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="507.01"
					x2="492.56"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="507.01"
					x2="492.56"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="511.85"
					x2="491.35"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="650.93"
					x2="492.56"
					y2="650.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="650.93"
					x2="492.56"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="649.73"
					x2="494.98"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="649.73"
					x2="494.98"
					y2="650.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="649.73"
					x2="492.56"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="654.56"
					x2="491.35"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="654.56"
					x2="491.35"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="649.73"
					x2="492.56"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="511.85"
					x2="504.65"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="507.01"
					x2="507.67"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.67"
					y1="507.01"
					x2="507.67"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.67"
					y1="511.85"
					x2="504.65"
					y2="511.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.67"
					y1="649.73"
					x2="507.67"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.67"
					y1="654.56"
					x2="504.65"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="654.56"
					x2="504.65"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="649.73"
					x2="507.67"
					y2="649.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="494.98 515.48 504.65 515.48 504.65 510.64 494.98 510.64 494.98 515.48"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="494.98 650.93 504.65 650.93 504.65 646.1 494.98 646.1 494.98 650.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.65 578.37 500.42 578.37 500.42 646.1 504.65 646.1 504.65 578.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="500.42 544.51 496.18 544.51 496.18 612.23 500.42 612.23 500.42 544.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.65"
					y1="510.64"
					x2="504.65"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="510.64"
					x2="494.98"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="494.98"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="650.93"
					x2="504.65"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="650.93"
					x2="494.98"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="494.98"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="515.48"
					x2="504.65"
					y2="515.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="515.48"
					x2="504.65"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="510.64"
					x2="494.98"
					y2="510.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="510.64"
					x2="494.98"
					y2="515.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="650.93"
					x2="504.65"
					y2="650.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="650.93"
					x2="504.65"
					y2="646.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="646.1"
					x2="494.98"
					y2="646.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="494.98"
					y1="646.1"
					x2="494.98"
					y2="650.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="578.37"
					x2="500.42"
					y2="578.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.42"
					y1="578.37"
					x2="500.42"
					y2="646.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.42"
					y1="646.1"
					x2="504.65"
					y2="646.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="646.1"
					x2="504.65"
					y2="578.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.42"
					y1="544.51"
					x2="496.18"
					y2="544.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.18"
					y1="544.51"
					x2="496.18"
					y2="612.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="496.18"
					y1="612.23"
					x2="500.42"
					y2="612.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="500.42"
					y1="612.23"
					x2="500.42"
					y2="544.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="494.98"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="494.98"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="510.04"
					x2="492.56"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="510.04"
					x2="504.65"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="510.04"
					x2="492.56"
					y2="510.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="510.04"
					x2="492.56"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="510.04"
					x2="492.56"
					y2="507.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="494.98"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="494.98"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="651.54"
					x2="492.56"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="651.54"
					x2="504.65"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="494.98"
					y1="651.54"
					x2="492.56"
					y2="651.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="651.54"
					x2="492.56"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="651.54"
					x2="492.56"
					y2="654.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="504.65 482.16 504.65 486.99 505.86 486.99 505.86 482.16 504.65 482.16"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="491.35 482.16 491.35 486.99 492.56 486.99 492.56 482.16 491.35 482.16"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.65"
					y1="392.66"
					x2="505.86"
					y2="392.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="482.16"
					x2="504.65"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="486.99"
					x2="505.86"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.86"
					y1="486.99"
					x2="505.86"
					y2="482.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.86"
					y1="482.16"
					x2="504.65"
					y2="482.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="392.66"
					x2="492.56"
					y2="392.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="482.16"
					x2="491.35"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.35"
					y1="486.99"
					x2="492.56"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="486.99"
					x2="492.56"
					y2="482.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="482.16"
					x2="491.35"
					y2="482.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="504.65 393.87 504.65 392.06 492.56 392.06 492.56 393.87 504.65 393.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="504.65 482.76 504.65 480.95 492.56 480.95 492.56 482.76 504.65 482.76"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="430.98 419.38 492.56 480.95 495.55 477.96 433.98 416.38 430.98 419.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="492.56"
					y1="392.06"
					x2="492.56"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="392.06"
					x2="504.65"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="391.45"
					x2="504.65"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="482.76"
					x2="492.56"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="482.76"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="393.87"
					x2="492.56"
					y2="393.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="393.87"
					x2="492.56"
					y2="392.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="392.06"
					x2="504.65"
					y2="392.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="392.06"
					x2="504.65"
					y2="393.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="482.76"
					x2="492.56"
					y2="482.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="482.76"
					x2="492.56"
					y2="480.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="480.95"
					x2="504.65"
					y2="480.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.65"
					y1="480.95"
					x2="504.65"
					y2="482.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.98"
					y1="419.38"
					x2="433.98"
					y2="416.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="433.98"
					y1="416.38"
					x2="495.55"
					y2="477.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.55"
					y1="477.96"
					x2="492.56"
					y2="480.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="480.95"
					x2="430.98"
					y2="419.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="391.45"
					x2="504.65"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="391.45"
					x2="504.65"
					y2="391.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="504.65"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="492.56"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="492.56"
					y1="483.37"
					x2="492.56"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="483.37"
					x2="504.65"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="504.65"
					y1="483.37"
					x2="504.65"
					y2="486.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="351.62"
					y1="677.87"
					x2="492.56"
					y2="677.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="273.1"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="276.72"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="491"
					x2="372.27"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="372.27"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="368.64"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="270.03"
					y1="503.09"
					x2="276.72"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="367.43 489.79 367.43 491 372.27 491 372.27 489.79 367.43 489.79"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="367.43 503.09 367.43 504.3 372.27 504.3 372.27 503.09 367.43 503.09"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="277.93 504.3 277.93 503.09 273.1 503.09 273.1 504.3 277.93 504.3"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="367.43"
					y1="489.79"
					x2="372.27"
					y2="489.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.27"
					y1="489.79"
					x2="372.27"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.27"
					y1="491"
					x2="367.43"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.43"
					y1="491"
					x2="367.43"
					y2="489.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.93"
					y1="489.79"
					x2="277.93"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.43"
					y1="503.09"
					x2="372.27"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.27"
					y1="503.09"
					x2="372.27"
					y2="504.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.27"
					y1="504.3"
					x2="367.43"
					y2="504.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.43"
					y1="504.3"
					x2="367.43"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.93"
					y1="504.3"
					x2="273.1"
					y2="504.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.1"
					y1="504.3"
					x2="273.1"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.1"
					y1="503.09"
					x2="277.93"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.93"
					y1="503.09"
					x2="277.93"
					y2="504.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="366.22 491 366.22 503.09 368.04 503.09 368.04 491 366.22 491"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="277.33 491 277.33 503.09 279.14 503.09 279.14 491 277.33 491"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="340.72 564.66 343.71 561.67 282.14 500.1 279.14 503.09 340.72 564.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="368.04"
					y1="503.09"
					x2="368.64"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.04"
					y1="491"
					x2="368.64"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="368.64"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.33"
					y1="503.09"
					x2="276.72"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.33"
					y1="491"
					x2="276.72"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="276.72"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.22"
					y1="491"
					x2="366.22"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="366.22"
					y1="503.09"
					x2="368.04"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.04"
					y1="503.09"
					x2="368.04"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.04"
					y1="491"
					x2="366.22"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.33"
					y1="491"
					x2="277.33"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="277.33"
					y1="503.09"
					x2="279.14"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.14"
					y1="503.09"
					x2="279.14"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.14"
					y1="491"
					x2="277.33"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.72"
					y1="564.66"
					x2="343.71"
					y2="561.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.71"
					y1="561.67"
					x2="282.14"
					y2="500.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="282.14"
					y1="500.1"
					x2="279.14"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.14"
					y1="503.09"
					x2="340.72"
					y2="564.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="368.64"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="368.64"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="372.27"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="503.09"
					x2="372.27"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="491"
					x2="372.27"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="368.64"
					y1="491"
					x2="372.27"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="276.72"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="276.72"
					y2="491"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="273.1"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="276.72"
					y1="503.09"
					x2="273.1"
					y2="503.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="267.74"
					y1="53.59"
					x2="266.76"
					y2="72.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="429.17"
					y1="61.74"
					x2="428.19"
					y2="81.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="531.19"
					y1="86.26"
					x2="532.17"
					y2="66.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="394.91 869.04 396.83 864.72 397.5 860.04 396.83 855.36 394.91 851.05 392.46 848.2 389.39 846.05 382.2 843.3 376.22 842.34 370.17 842.7 364.35 844.38 359.03 844.23 353.88 842.89 349.17 840.4 347.13 839.1 342.93 837.56 338.46 837.8 336.69 838.49 332 838.49 332 840.45 334.14 840.45 332.15 843.73 331.38 847.48 331.38 872.61 332.14 876.32 334.2 879.5 337.26 881.72 340.93 882.67 341.51 882.67 344.53 882.18 349.28 879.62 353.94 877.16 359.03 875.82 364.29 875.69 370.13 877.38 376.2 877.75 382.2 876.78 389.39 874.04 392.46 871.88 394.91 869.04"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="353.72"
					y1="851.09"
					x2="353.72"
					y2="869"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="872.61"
					x2="331.38"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="872.61"
					x2="332.29"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="847.48"
					x2="331.38"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="847.48"
					x2="332.29"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.72"
					y1="868.53"
					x2="350.38"
					y2="868.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.38"
					y1="868.53"
					x2="350.38"
					y2="865.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.38"
					y1="865.76"
					x2="353.72"
					y2="865.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.72"
					y1="851.55"
					x2="350.38"
					y2="851.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.38"
					y1="851.55"
					x2="350.38"
					y2="854.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="350.38"
					y1="854.32"
					x2="353.72"
					y2="854.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.31"
					y1="840.45"
					x2="332"
					y2="840.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.31"
					y1="838.49"
					x2="332"
					y2="838.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332"
					y1="838.49"
					x2="332"
					y2="840.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.31"
					y1="838.49"
					x2="340.31"
					y2="840.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.5"
					y1="860.04"
					x2="397.16"
					y2="863.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="863.04"
					x2="396.38"
					y2="865.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.38"
					y1="865.95"
					x2="394.91"
					y2="869.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.91"
					y1="869.04"
					x2="392.46"
					y2="871.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.46"
					y1="871.89"
					x2="389.39"
					y2="874.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.39"
					y1="874.04"
					x2="385.9"
					y2="875.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.9"
					y1="875.63"
					x2="382.2"
					y2="876.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.2"
					y1="876.78"
					x2="376.21"
					y2="877.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.21"
					y1="877.83"
					x2="373.18"
					y2="877.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.18"
					y1="877.88"
					x2="370.17"
					y2="877.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.17"
					y1="877.54"
					x2="365.5"
					y2="876.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.5"
					y1="876.18"
					x2="360.99"
					y2="874.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.99"
					y1="874.07"
					x2="356.95"
					y2="871.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.95"
					y1="871.55"
					x2="353.72"
					y2="869"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.29"
					y1="875.69"
					x2="360.1"
					y2="875.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.1"
					y1="875.71"
					x2="356.02"
					y2="876.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.02"
					y1="876.4"
					x2="353.82"
					y2="877.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.82"
					y1="877.11"
					x2="351.65"
					y2="878.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.65"
					y1="878.14"
					x2="348.48"
					y2="880.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.48"
					y1="880.16"
					x2="345.2"
					y2="881.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.2"
					y1="881.94"
					x2="342"
					y2="882.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342"
					y1="882.65"
					x2="338.81"
					y2="882.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.81"
					y1="882.38"
					x2="335.9"
					y2="881.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.9"
					y1="881.14"
					x2="334.65"
					y2="880.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.65"
					y1="880.16"
					x2="333.57"
					y2="878.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.57"
					y1="878.94"
					x2="332.38"
					y2="876.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.38"
					y1="876.8"
					x2="331.72"
					y2="874.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.72"
					y1="874.75"
					x2="331.38"
					y2="872.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="872.61"
					x2="332.38"
					y2="873.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.38"
					y1="873.57"
					x2="332.99"
					y2="875.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.99"
					y1="875.54"
					x2="334.47"
					y2="877.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.47"
					y1="877.29"
					x2="336.51"
					y2="878.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.51"
					y1="878.38"
					x2="339.21"
					y2="878.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="878.9"
					x2="341.99"
					y2="879.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.99"
					y1="879.02"
					x2="343.37"
					y2="879"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.37"
					y1="879"
					x2="344.47"
					y2="878.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.47"
					y1="878.42"
					x2="344.79"
					y2="877.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.79"
					y1="877.74"
					x2="346.95"
					y2="870.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.95"
					y1="870.14"
					x2="347.59"
					y2="866.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.59"
					y1="866.36"
					x2="347.86"
					y2="862.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.86"
					y1="862.54"
					x2="347.86"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="364.35"
					y1="844.38"
					x2="360.15"
					y2="844.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.15"
					y1="844.34"
					x2="356.05"
					y2="843.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.05"
					y1="843.66"
					x2="353.84"
					y2="842.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.84"
					y1="842.96"
					x2="351.65"
					y2="841.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.65"
					y1="841.95"
					x2="348.47"
					y2="839.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.47"
					y1="839.94"
					x2="345.2"
					y2="838.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="345.2"
					y1="838.15"
					x2="343.06"
					y2="837.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.06"
					y1="837.56"
					x2="340.87"
					y2="837.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.87"
					y1="837.42"
					x2="338.71"
					y2="837.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.71"
					y1="837.73"
					x2="336.69"
					y2="838.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.29"
					y1="847.48"
					x2="332.38"
					y2="846.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.38"
					y1="846.52"
					x2="332.99"
					y2="844.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.99"
					y1="844.55"
					x2="334.47"
					y2="842.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.47"
					y1="842.8"
					x2="336.51"
					y2="841.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.51"
					y1="841.71"
					x2="339.21"
					y2="841.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.21"
					y1="841.18"
					x2="341.99"
					y2="841.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="341.99"
					y1="841.06"
					x2="343.37"
					y2="841.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.37"
					y1="841.08"
					x2="344.47"
					y2="841.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.47"
					y1="841.67"
					x2="344.79"
					y2="842.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.79"
					y1="842.35"
					x2="346.95"
					y2="849.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.95"
					y1="849.95"
					x2="347.59"
					y2="853.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.59"
					y1="853.72"
					x2="347.86"
					y2="857.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.86"
					y1="857.55"
					x2="347.86"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.5"
					y1="860.04"
					x2="397.16"
					y2="857.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="397.16"
					y1="857.04"
					x2="396.38"
					y2="854.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="396.38"
					y1="854.14"
					x2="394.91"
					y2="851.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="394.91"
					y1="851.05"
					x2="392.46"
					y2="848.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="392.46"
					y1="848.2"
					x2="389.39"
					y2="846.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.39"
					y1="846.05"
					x2="385.9"
					y2="844.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.9"
					y1="844.46"
					x2="382.2"
					y2="843.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.2"
					y1="843.3"
					x2="376.21"
					y2="842.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="376.21"
					y1="842.26"
					x2="373.18"
					y2="842.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="373.18"
					y1="842.21"
					x2="370.17"
					y2="842.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.17"
					y1="842.54"
					x2="365.5"
					y2="843.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.5"
					y1="843.9"
					x2="360.99"
					y2="846.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.99"
					y1="846.02"
					x2="356.95"
					y2="848.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="356.95"
					y1="848.54"
					x2="353.72"
					y2="851.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.94"
					y1="881.1"
					x2="347.62"
					y2="880.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.62"
					y1="880.61"
					x2="348.64"
					y2="879.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.64"
					y1="879.24"
					x2="348.89"
					y2="878.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.89"
					y1="878.03"
					x2="349.55"
					y2="870.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.55"
					y1="870.32"
					x2="349.85"
					y2="862.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.85"
					y1="862.58"
					x2="349.85"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="346.94"
					y1="838.99"
					x2="347.62"
					y2="839.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="347.62"
					y1="839.47"
					x2="348.64"
					y2="840.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.64"
					y1="840.85"
					x2="348.89"
					y2="842.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="348.89"
					y1="842.05"
					x2="349.55"
					y2="849.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.55"
					y1="849.77"
					x2="349.85"
					y2="857.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="349.85"
					y1="857.51"
					x2="349.85"
					y2="860.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.14"
					y1="840.45"
					x2="333.57"
					y2="841.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.57"
					y1="841.14"
					x2="332.38"
					y2="843.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.38"
					y1="843.29"
					x2="331.73"
					y2="845.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.73"
					y1="845.34"
					x2="331.38"
					y2="847.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="331.38 889.07 332.35 889.07 332.35 884.23 331.38 884.23 331.38 889.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="331.38"
					y1="884.23"
					x2="331.38"
					y2="889.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="884.23"
					x2="331.38"
					y2="884.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="889.07"
					x2="332.35"
					y2="884.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="889.07"
					x2="332.35"
					y2="889.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="331.38 831.02 331.38 835.85 332.35 835.85 332.35 831.02 331.38 831.02"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.35"
					y1="831.02"
					x2="331.38"
					y2="831.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="835.85"
					x2="332.35"
					y2="831.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="835.85"
					x2="332.35"
					y2="835.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="831.02"
					x2="331.38"
					y2="835.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.35 887.13 340.22 887.13 340.22 886.17 332.35 886.17 332.35 887.13"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="332.35"
					y1="886.17"
					x2="332.35"
					y2="887.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.22"
					y1="886.17"
					x2="332.35"
					y2="886.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.22"
					y1="887.13"
					x2="340.22"
					y2="886.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="887.13"
					x2="340.22"
					y2="887.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="332.35 832.95 332.35 833.92 340.22 833.92 340.22 832.95 332.35 832.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="340.22"
					y1="832.95"
					x2="332.35"
					y2="832.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="340.22"
					y1="833.92"
					x2="340.22"
					y2="832.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="833.92"
					x2="340.22"
					y2="833.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.35"
					y1="832.95"
					x2="332.35"
					y2="833.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="337.81 886.17 339.74 886.17 339.74 833.92 337.81 833.92 337.81 886.17"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="337.81"
					y1="833.92"
					x2="337.81"
					y2="886.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.74"
					y1="833.92"
					x2="337.81"
					y2="833.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.74"
					y1="886.17"
					x2="339.74"
					y2="833.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.81"
					y1="886.17"
					x2="339.74"
					y2="886.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="351.62 677.87 351.62 751.88 492.56 751.88 492.56 677.87 351.62 677.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="492.56"
					y1="677.87"
					x2="351.62"
					y2="677.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.56"
					y1="751.88"
					x2="492.56"
					y2="677.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.62"
					y1="751.88"
					x2="492.56"
					y2="751.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.62"
					y1="677.87"
					x2="351.62"
					y2="751.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="360.45 686.63 360.45 742.15 483.12 742.15 483.12 686.63 360.45 686.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="483.12"
					y1="686.63"
					x2="360.45"
					y2="686.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.12"
					y1="742.15"
					x2="483.12"
					y2="686.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.45"
					y1="742.15"
					x2="483.12"
					y2="742.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.45"
					y1="686.63"
					x2="360.45"
					y2="742.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="372.51 714.88 372.47 714.38 372.34 713.89 372.15 713.44 371.88 713.03 371.55 712.68 371.16 712.39 370.74 712.18 370.29 712.05 369.82 712 369.35 712.05 368.9 712.18 368.47 712.39 368.09 712.68 367.75 713.03 367.49 713.44 367.29 713.89 367.17 714.38 367.12 714.88 367.17 715.37 367.29 715.86 367.49 716.31 367.75 716.72 368.09 717.07 368.47 717.36 368.9 717.57 369.35 717.7 369.82 717.75 370.29 717.7 370.74 717.57 371.16 717.36 371.55 717.07 371.88 716.72 372.15 716.31 372.34 715.86 372.47 715.37 372.51 714.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="372.47"
					y1="715.37"
					x2="372.51"
					y2="714.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.34"
					y1="715.86"
					x2="372.47"
					y2="715.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.15"
					y1="716.31"
					x2="372.34"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.88"
					y1="716.72"
					x2="372.15"
					y2="716.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.55"
					y1="717.07"
					x2="371.88"
					y2="716.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.16"
					y1="717.36"
					x2="371.55"
					y2="717.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.74"
					y1="717.57"
					x2="371.16"
					y2="717.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.29"
					y1="717.7"
					x2="370.74"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.82"
					y1="717.75"
					x2="370.29"
					y2="717.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.35"
					y1="717.7"
					x2="369.82"
					y2="717.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.9"
					y1="717.57"
					x2="369.35"
					y2="717.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.47"
					y1="717.36"
					x2="368.9"
					y2="717.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.09"
					y1="717.07"
					x2="368.47"
					y2="717.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.75"
					y1="716.72"
					x2="368.09"
					y2="717.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.49"
					y1="716.31"
					x2="367.75"
					y2="716.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.29"
					y1="715.86"
					x2="367.49"
					y2="716.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.17"
					y1="715.37"
					x2="367.29"
					y2="715.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.12"
					y1="714.88"
					x2="367.17"
					y2="715.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.17"
					y1="714.38"
					x2="367.12"
					y2="714.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.29"
					y1="713.89"
					x2="367.17"
					y2="714.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.49"
					y1="713.44"
					x2="367.29"
					y2="713.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367.75"
					y1="713.03"
					x2="367.49"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.09"
					y1="712.68"
					x2="367.75"
					y2="713.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.47"
					y1="712.39"
					x2="368.09"
					y2="712.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.9"
					y1="712.18"
					x2="368.47"
					y2="712.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.35"
					y1="712.05"
					x2="368.9"
					y2="712.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="369.82"
					y1="712"
					x2="369.35"
					y2="712.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.29"
					y1="712.05"
					x2="369.82"
					y2="712"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.74"
					y1="712.18"
					x2="370.29"
					y2="712.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.16"
					y1="712.39"
					x2="370.74"
					y2="712.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.55"
					y1="712.68"
					x2="371.16"
					y2="712.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.88"
					y1="713.03"
					x2="371.55"
					y2="712.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.15"
					y1="713.44"
					x2="371.88"
					y2="713.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.34"
					y1="713.89"
					x2="372.15"
					y2="713.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.47"
					y1="714.38"
					x2="372.34"
					y2="713.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="372.51"
					y1="714.88"
					x2="372.47"
					y2="714.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="357.3 717.35 356.9 717.31 356.51 717.2 356.14 717.02 355.81 716.77 355.53 716.47 355.29 716.11 355.12 715.72 355.02 715.3 354.98 714.88 355.02 714.44 355.12 714.03 355.29 713.64 355.53 713.28 355.81 712.98 356.14 712.73 356.51 712.55 356.9 712.43 357.3 712.4 361.2 712.79 361.51 712.85 361.81 712.96 362.08 713.12 367 713.77 367.17 713.81 367.34 713.88 367.49 713.98 367.62 714.11 367.73 714.25 367.82 714.42 367.88 714.59 367.91 714.78 367.91 714.97 367.88 715.15 367.82 715.33 367.73 715.5 367.62 715.64 367.49 715.77 367.34 715.86 367.17 715.93 367 715.97 362.08 716.63 361.81 716.79 361.51 716.9 361.2 716.96 357.3 717.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="357.3"
					y1="717.35"
					x2="361.2"
					y2="716.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.08"
					y1="716.63"
					x2="367"
					y2="715.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="367"
					y1="713.77"
					x2="362.08"
					y2="713.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361.2"
					y1="712.79"
					x2="357.3"
					y2="712.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.62"
					y1="713.53"
					x2="361"
					y2="713.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="361"
					y1="716.22"
					x2="359.62"
					y2="716.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="359.62"
					y1="716.22"
					x2="359.62"
					y2="713.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m362.08,716.63c-.27.18-.57.29-.88.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m367,713.77c.52.07.91.54.91,1.1s-.39,1.03-.91,1.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m361.2,712.79c.31.03.62.14.88.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m357.3,717.35c-1.28,0-2.32-1.11-2.32-2.47s1.04-2.48,2.32-2.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m361,713.53c.7,0,1.26.6,1.26,1.35s-.57,1.35-1.26,1.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m362.08,713.12c.56.39.9,1.04.9,1.76s-.34,1.37-.9,1.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="708.93 670.8 764.12 670.8 764.12 616.56 708.93 616.56 708.93 670.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.93"
					y1="616.56"
					x2="708.93"
					y2="618.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="622.2"
					x2="708.93"
					y2="628.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="631.49"
					x2="708.93"
					y2="637.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="640.78"
					x2="708.93"
					y2="646.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="650.07"
					x2="708.93"
					y2="655.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="659.36"
					x2="708.93"
					y2="665.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="668.64"
					x2="708.93"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="616.56"
					x2="761.49"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758"
					y1="616.56"
					x2="752.2"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.71"
					y1="616.56"
					x2="742.91"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.43"
					y1="616.56"
					x2="733.62"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.14"
					y1="616.56"
					x2="724.33"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.85"
					y1="616.56"
					x2="715.05"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="711.56"
					y1="616.56"
					x2="708.93"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="670.8"
					x2="764.12"
					y2="668.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="665.16"
					x2="764.12"
					y2="659.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="655.87"
					x2="764.12"
					y2="650.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="646.59"
					x2="764.12"
					y2="640.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="637.3"
					x2="764.12"
					y2="631.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="628.01"
					x2="764.12"
					y2="622.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="618.72"
					x2="764.12"
					y2="616.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="670.8"
					x2="711.56"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="715.05"
					y1="670.8"
					x2="720.85"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="724.33"
					y1="670.8"
					x2="730.14"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="733.62"
					y1="670.8"
					x2="739.43"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.91"
					y1="670.8"
					x2="748.71"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.2"
					y1="670.8"
					x2="758"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.49"
					y1="670.8"
					x2="764.12"
					y2="670.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="706.07 616.76 704.41 616.76 704.41 670.6 706.07 670.6 706.07 662.15 704.71 662.15 704.71 625.21 706.07 625.21 706.07 616.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="706.07"
					y1="625.21"
					x2="706.07"
					y2="616.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.71"
					y1="625.21"
					x2="706.07"
					y2="625.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.71"
					y1="662.15"
					x2="704.71"
					y2="625.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="662.15"
					x2="704.71"
					y2="662.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="670.6"
					x2="706.07"
					y2="662.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.41"
					y1="670.6"
					x2="706.07"
					y2="670.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="704.41"
					y1="616.76"
					x2="704.41"
					y2="670.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="616.76"
					x2="704.41"
					y2="616.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="706.07 614.65 706.07 672.71 708.93 672.71 708.93 614.65 706.07 614.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="708.93"
					y1="614.65"
					x2="706.07"
					y2="614.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="708.93"
					y1="672.71"
					x2="708.93"
					y2="614.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="672.71"
					x2="708.93"
					y2="672.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="614.65"
					x2="706.07"
					y2="672.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="706.07"
					y1="670.6"
					x2="704.41"
					y2="670.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.41"
					y1="670.6"
					x2="704.41"
					y2="616.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.41"
					y1="616.76"
					x2="706.07"
					y2="616.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="672.71"
					x2="706.07"
					y2="614.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="625.21"
					x2="704.71"
					y2="625.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.71"
					y1="625.21"
					x2="704.71"
					y2="662.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.71"
					y1="662.15"
					x2="706.07"
					y2="662.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="672.71"
					x2="706.07"
					y2="672.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="614.65"
					x2="708.93"
					y2="614.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="708.93"
					y1="614.65"
					x2="708.93"
					y2="672.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="697.5 924.65 697.5 844.6 784.04 844.6 784.04 924.65 697.5 924.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="697.5"
					y1="924.65"
					x2="697.5"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.5"
					y1="844.6"
					x2="784.04"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.04"
					y1="844.6"
					x2="784.04"
					y2="924.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.04"
					y1="924.65"
					x2="697.5"
					y2="924.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.55"
					y1="924.65"
					x2="703.55"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="713.02 679.57 713.02 739.82 713.28 740.77 713.97 741.47 714.93 741.72 755.26 741.72 756.22 741.47 756.91 740.77 757.17 739.82 757.17 679.57 756.91 678.62 756.22 677.92 755.26 677.67 714.93 677.67 713.97 677.92 713.28 678.62 713.02 679.57"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m713.02,679.57c0-1.05.85-1.9,1.91-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.26"
					y1="677.67"
					x2="714.93"
					y2="677.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.26,677.67c1.05,0,1.91.85,1.91,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="757.17"
					y1="739.82"
					x2="757.17"
					y2="679.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.17,739.82c0,1.05-.85,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="714.93"
					y1="741.72"
					x2="755.26"
					y2="741.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m714.93,741.72c-1.05,0-1.91-.85-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="713.02"
					y1="679.57"
					x2="713.02"
					y2="739.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.79"
					y1="684.33"
					x2="717.79"
					y2="735.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.69"
					y1="736.96"
					x2="745.74"
					y2="736.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.65"
					y1="735.06"
					x2="747.65"
					y2="684.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="745.74"
					y1="682.43"
					x2="719.69"
					y2="682.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.79"
					y1="684.33"
					x2="717.79"
					y2="684.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m719.69,736.96c-1.05,0-1.91-.85-1.91-1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m747.65,735.06c0,1.05-.85,1.91-1.91,1.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m745.74,682.43c1.05,0,1.91.85,1.91,1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m717.79,684.33c0-1.05.85-1.9,1.91-1.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m740.98,709.7c0-1.58-1.28-2.86-2.86-2.86s-2.86,1.28-2.86,2.86,1.28,2.86,2.86,2.86,2.86-1.28,2.86-2.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="735.47 708.84 734.86 709.09 734.61 709.7 734.87 710.3 735.47 710.55 754.31 710.55 754.92 710.3 755.17 709.7 754.92 709.09 754.31 708.84 735.47 708.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="754.31"
					y1="708.84"
					x2="735.47"
					y2="708.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.31,708.84c.47,0,.86.38.86.86s-.39.86-.86.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.47"
					y1="710.55"
					x2="754.31"
					y2="710.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m735.47,710.55h0c-.48,0-.86-.39-.86-.86s.38-.86.85-.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="749.46 707.79 749.46 708.84 754.31 708.84 754.92 709.09 755.17 709.7 754.92 710.3 754.31 710.55 749.46 710.55 749.46 711.6 755.65 711.6 755.65 707.79 749.46 707.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.65"
					y1="707.79"
					x2="749.46"
					y2="707.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.65"
					y1="711.6"
					x2="755.65"
					y2="707.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.46"
					y1="711.6"
					x2="755.65"
					y2="711.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.46"
					y1="710.55"
					x2="749.46"
					y2="711.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.31"
					y1="710.55"
					x2="749.46"
					y2="710.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m754.31,708.84c.47,0,.86.38.86.86s-.39.86-.86.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.46"
					y1="708.84"
					x2="754.31"
					y2="708.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.46"
					y1="707.79"
					x2="749.46"
					y2="708.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="746.03 707.82 746.03 708.84 749.36 708.84 749.36 707.82 746.03 707.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="749.36"
					y1="707.82"
					x2="746.03"
					y2="707.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.36"
					y1="708.84"
					x2="749.36"
					y2="707.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.03"
					y1="708.84"
					x2="749.36"
					y2="708.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.03"
					y1="707.82"
					x2="746.03"
					y2="708.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="746.03 711.57 749.36 711.57 749.36 710.55 746.03 710.55 746.03 711.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="746.03"
					y1="710.55"
					x2="746.03"
					y2="711.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.36"
					y1="710.55"
					x2="746.03"
					y2="710.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="749.36"
					y1="711.57"
					x2="749.36"
					y2="710.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.03"
					y1="711.57"
					x2="749.36"
					y2="711.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="379.74 818.35 379.74 755.47 331.38 755.47 331.38 818.35 379.74 818.35"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="379.74"
					y1="818.35"
					x2="379.74"
					y2="755.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="331.38"
					y1="818.35"
					x2="331.38"
					y2="755.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.74"
					y1="755.47"
					x2="331.38"
					y2="755.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.74"
					y1="818.35"
					x2="331.38"
					y2="818.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="333.29"
					y1="818.35"
					x2="333.29"
					y2="755.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.26"
					y1="811.1"
					x2="368.26"
					y2="762.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="368.26"
					y1="762.72"
					x2="339.24"
					y2="762.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.24"
					y1="762.72"
					x2="339.24"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.24"
					y1="811.1"
					x2="368.26"
					y2="811.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.16"
					y1="813"
					x2="370.16"
					y2="760.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="370.16"
					y1="760.82"
					x2="337.33"
					y2="760.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.33"
					y1="760.82"
					x2="337.33"
					y2="813"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.33"
					y1="813"
					x2="370.16"
					y2="813"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m348.64,786.91c0-1.58-1.28-2.86-2.86-2.86s-2.86,1.28-2.86,2.86,1.28,2.86,2.86,2.86,2.86-1.28,2.86-2.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="334 789.29 337.99 788.91 338.9 788.6 343.94 787.97 344.61 787.62 344.87 786.91 344.61 786.21 343.94 785.86 338.9 785.22 337.99 784.91 334 784.53 332.6 784.98 331.73 786.18 331.73 787.65 332.6 788.84 334 789.29"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m334,789.29c-1.32,0-2.38-1.06-2.38-2.38s1.06-2.38,2.38-2.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.99"
					y1="784.91"
					x2="334"
					y2="784.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m337.99,784.91c.32.03.63.14.9.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="343.94"
					y1="785.86"
					x2="338.9"
					y2="785.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m343.94,785.86c.53.07.93.52.93,1.05s-.4.99-.93,1.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.9"
					y1="788.6"
					x2="343.94"
					y2="787.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m338.9,788.6c-.27.17-.58.28-.9.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334"
					y1="789.29"
					x2="337.99"
					y2="788.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.37"
					y1="785.62"
					x2="337.79"
					y2="785.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="337.79"
					y1="788.21"
					x2="336.37"
					y2="788.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.37"
					y1="788.21"
					x2="336.37"
					y2="785.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m337.79,785.62c.72,0,1.3.58,1.3,1.29s-.58,1.3-1.3,1.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m338.9,785.22c.58.37.92,1,.92,1.69s-.34,1.32-.92,1.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="545.44"
					x2="723.11"
					y2="545.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="723.11"
					y1="545.44"
					x2="723.11"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="554.29"
					x2="738.6"
					y2="494.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.44"
					y1="494.53"
					x2="778.44"
					y2="554.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.44"
					y1="554.29"
					x2="718.68"
					y2="554.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.68"
					y1="494.53"
					x2="778.44"
					y2="494.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.78"
					y1="554.29"
					x2="719.78"
					y2="494.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="738.6"
					y1="503.38"
					x2="723.11"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="718.68"
					y1="554.29"
					x2="718.68"
					y2="494.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.5"
					y1="847.26"
					x2="692.23"
					y2="847.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.23"
					y1="847.26"
					x2="692.23"
					y2="849.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.23"
					y1="849.93"
					x2="697.5"
					y2="849.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="924.65"
					x2="706.07"
					y2="918.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="915.39"
					x2="706.07"
					y2="909.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="906.11"
					x2="706.07"
					y2="900.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="896.82"
					x2="706.07"
					y2="891.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="887.53"
					x2="706.07"
					y2="881.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="878.24"
					x2="706.07"
					y2="872.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="868.95"
					x2="706.07"
					y2="863.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="859.66"
					x2="706.07"
					y2="853.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="850.38"
					x2="706.07"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.07"
					y1="613.21"
					x2="706.07"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.74"
					y1="53.59"
					x2="429.17"
					y2="61.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.19"
					y1="81.06"
					x2="266.76"
					y2="72.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="721.86"
					y1="76.51"
					x2="532.17"
					y2="66.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="531.19"
					y1="86.26"
					x2="720.88"
					y2="95.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.8"
					y1="545.44"
					x2="771.8"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.8"
					y1="503.38"
					x2="743.03"
					y2="503.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.03"
					y1="503.38"
					x2="743.03"
					y2="545.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.03"
					y1="545.44"
					x2="771.8"
					y2="545.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="701.23 746.68 701.23 819.25 764.12 819.25 764.12 746.68 701.23 746.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="701.23"
					y1="746.68"
					x2="701.23"
					y2="819.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.12"
					y1="746.68"
					x2="764.12"
					y2="819.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="762.22"
					y1="746.68"
					x2="762.22"
					y2="819.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.23"
					y1="746.68"
					x2="764.12"
					y2="746.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.23"
					y1="819.25"
					x2="764.12"
					y2="819.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.09"
					y1="751.44"
					x2="704.09"
					y2="814.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="704.09"
					y1="814.49"
					x2="706"
					y2="816.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706"
					y1="816.39"
					x2="759.36"
					y2="816.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.36"
					y1="816.39"
					x2="761.26"
					y2="814.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.26"
					y1="814.49"
					x2="761.26"
					y2="751.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.26"
					y1="751.44"
					x2="759.36"
					y2="749.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.36"
					y1="749.54"
					x2="706"
					y2="749.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706"
					y1="749.54"
					x2="704.09"
					y2="751.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m726.48,764.82c0-5.26-4.26-9.52-9.52-9.52s-9.52,4.26-9.52,9.52,4.26,9.52,9.52,9.52,9.52-4.26,9.52-9.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m755.54,764.82c0-3.94-3.2-7.14-7.14-7.14s-7.14,3.2-7.14,7.14,3.2,7.14,7.14,7.14,7.14-3.2,7.14-7.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m724.1,801.11c0-3.94-3.2-7.14-7.14-7.14s-7.14,3.2-7.14,7.14,3.2,7.14,7.14,7.14,7.14-3.2,7.14-7.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m757.92,801.11c0-5.26-4.26-9.52-9.52-9.52s-9.52,4.26-9.52,9.52,4.26,9.52,9.52,9.52,9.52-4.27,9.52-9.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="613.21"
					x2="735.1"
					y2="615.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="619.19"
					x2="735.1"
					y2="624.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="628.47"
					x2="735.1"
					y2="634.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="637.76"
					x2="735.1"
					y2="643.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="647.05"
					x2="735.1"
					y2="652.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="656.34"
					x2="735.1"
					y2="662.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="665.63"
					x2="735.1"
					y2="671.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="674.92"
					x2="735.1"
					y2="680.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="684.2"
					x2="735.1"
					y2="690.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="693.49"
					x2="735.1"
					y2="699.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="702.78"
					x2="735.1"
					y2="708.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="712.07"
					x2="735.1"
					y2="717.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="721.36"
					x2="735.1"
					y2="727.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="730.65"
					x2="735.1"
					y2="736.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="739.94"
					x2="735.1"
					y2="745.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="749.22"
					x2="735.1"
					y2="755.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="758.51"
					x2="735.1"
					y2="764.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="767.8"
					x2="735.1"
					y2="773.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="777.09"
					x2="735.1"
					y2="782.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="786.37"
					x2="735.1"
					y2="792.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="795.66"
					x2="735.1"
					y2="801.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="804.95"
					x2="735.1"
					y2="810.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="814.24"
					x2="735.1"
					y2="820.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="823.53"
					x2="735.1"
					y2="829.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="832.82"
					x2="735.1"
					y2="838.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.1"
					y1="842.1"
					x2="735.1"
					y2="844.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="803.39 80.62 803.39 950 784.05 948.91 611.29 939.18 612.38 919.85 697.61 924.66 784.05 924.66 784.05 844.6 764.12 844.6 764.12 613.21 704.72 613.21 704.72 558.55 716.82 558.55 716.82 563.99 784.05 563.99 784.05 485.55 716.82 485.55 716.82 490.83 704.72 490.83 704.72 473.45 784.05 473.45 784.05 144.74 772.4 144.74 772.4 98.44 720.88 95.84 721.86 76.51 784.05 79.65 803.39 80.62"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="520.62 914.69 519.53 934 331.38 923.4 312.03 922.31 312.03 685.12 250.67 685.12 250.67 489.87 196.61 489.87 196.61 50 215.95 50.98 267.74 53.59 266.76 72.91 228.4 70.97 228.4 114.59 215.95 114.59 215.95 402 263.61 402 263.61 470.52 270.03 470.52 270.03 491 276.72 491 276.72 503.09 270.03 503.09 270.03 665.77 412.47 665.77 412.47 503.09 368.64 503.09 368.64 491 492.56 491 492.56 483.37 504.66 483.37 504.66 510.04 492.56 510.04 492.56 503.09 424.56 503.09 424.56 665.77 492.56 665.77 492.56 651.54 504.66 651.54 504.66 804.41 492.56 804.41 492.56 677.86 351.62 677.86 351.62 751.88 331.38 751.88 331.38 901.54 492.56 901.54 492.56 896.33 504.66 896.33 504.66 913.43 498.27 913.43 520.62 914.69"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
				<polygon
					points="532.17 66.94 531.19 86.27 504.66 84.93 504.66 391.45 492.56 391.45 492.56 163.19 437.95 163.19 437.95 81.55 428.2 81.07 429.17 61.74 532.17 66.94"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.14"
				/>
			</g>
			<g id="text">
				<path d="m737.19,648.74v-11.21h3.86c.87,0,1.54.05,2,.16.64.15,1.19.42,1.64.8.59.5,1.03,1.14,1.32,1.92.3.77.44,1.66.44,2.66,0,.85-.1,1.61-.3,2.26-.2.66-.45,1.2-.76,1.64-.31.43-.65.77-1.02,1.02-.37.24-.81.43-1.34.56-.52.13-1.12.19-1.8.19h-4.05Zm1.48-1.32h2.39c.74,0,1.32-.07,1.74-.21.42-.14.76-.33,1.01-.58.35-.35.62-.82.82-1.41.2-.6.3-1.32.3-2.16,0-1.17-.19-2.07-.58-2.7-.38-.63-.85-1.06-1.4-1.27-.4-.15-1.04-.23-1.92-.23h-2.36v8.57Zm11.79,1.32l-2.98-11.21h1.52l1.71,7.35c.18.77.34,1.53.47,2.29.29-1.2.45-1.89.5-2.07l2.13-7.57h1.79l1.61,5.67c.4,1.41.69,2.73.87,3.97.14-.71.33-1.52.56-2.44l1.76-7.2h1.49l-3.07,11.21h-1.43l-2.36-8.54c-.2-.71-.32-1.15-.35-1.32-.12.52-.23.95-.33,1.32l-2.38,8.54h-1.51Z" />
				<path d="m737.23,891.35h-1.58l-1.89-3.17c-.17-.29-.34-.54-.5-.75-.16-.21-.33-.38-.5-.51-.17-.13-.35-.23-.55-.28-.19-.06-.41-.09-.66-.09h-1.09v4.8h-1.32v-11.3h3.37c.49,0,.95.06,1.36.19.42.12.78.31,1.09.56.31.25.55.57.72.95.17.37.26.81.26,1.32,0,.39-.06.76-.18,1.09-.12.33-.28.62-.5.87-.22.26-.48.48-.79.66-.3.18-.65.32-1.03.42v.03c.19.08.35.18.49.29.14.1.28.23.4.38.13.15.25.31.37.5.13.18.27.4.42.65l2.12,3.39Zm-6.77-10.1v4.1h1.8c.33,0,.64-.05.91-.15.28-.1.53-.24.73-.43.2-.19.37-.42.48-.69.12-.27.17-.58.17-.91,0-.6-.2-1.07-.59-1.41-.39-.34-.95-.51-1.69-.51h-1.81Zm14.49,6.39h-5.69c.02.9.26,1.59.72,2.08.46.49,1.1.73,1.91.73.91,0,1.74-.3,2.5-.9v1.21c-.71.51-1.65.77-2.81.77s-2.03-.36-2.69-1.09c-.65-.74-.98-1.77-.98-3.1,0-1.26.35-2.28,1.06-3.06.71-.79,1.6-1.19,2.65-1.19s1.87.34,2.45,1.02c.58.68.87,1.63.87,2.84v.68Zm-1.32-1.09c0-.75-.19-1.33-.54-1.74-.35-.41-.84-.62-1.47-.62s-1.13.22-1.55.65-.69,1.01-.79,1.71h4.36Zm7.12-6c-.25-.14-.54-.21-.86-.21-.9,0-1.35.57-1.35,1.71v1.24h1.89v1.1h-1.89v6.96h-1.28v-6.96h-1.38v-1.1h1.38v-1.31c0-.85.24-1.51.73-2,.49-.49,1.1-.74,1.83-.74.39,0,.71.05.94.14v1.17Z" />
				<path d="m752.1,891.52c-.24,0-.45-.09-.62-.26-.17-.17-.25-.38-.25-.62s.08-.45.25-.62c.17-.18.38-.27.62-.27s.46.09.63.27c.17.17.26.38.26.62s-.09.45-.26.62c-.17.17-.38.26-.63.26Z" />
				<path d="m413.57,798.28v-17.53h4.99c1.52,0,2.72.37,3.61,1.11.89.74,1.33,1.71,1.33,2.9,0,.99-.27,1.86-.81,2.59s-1.28,1.26-2.22,1.56v.05c1.18.14,2.13.59,2.84,1.34.71.75,1.06,1.73,1.06,2.93,0,1.5-.54,2.71-1.61,3.64-1.08.93-2.43,1.39-4.07,1.39h-5.11Zm2.05-15.67v5.66h2.1c1.12,0,2.01-.27,2.65-.81.64-.55.97-1.31.97-2.3,0-1.7-1.12-2.55-3.36-2.55h-2.36Zm0,7.51v6.31h2.79c1.21,0,2.14-.29,2.8-.86.67-.57,1-1.35,1-2.35,0-2.07-1.41-3.11-4.23-3.11h-2.36Zm20.99,8.17h-2v-1.96h-.05c-.87,1.5-2.16,2.25-3.85,2.25-1.25,0-2.22-.33-2.93-.99-.7-.66-1.05-1.54-1.05-2.63,0-2.34,1.38-3.7,4.13-4.08l3.75-.53c0-2.13-.86-3.19-2.58-3.19-1.51,0-2.87.51-4.08,1.54v-2.05c1.23-.78,2.65-1.17,4.25-1.17,2.94,0,4.41,1.56,4.41,4.67v8.14Zm-2-6.33l-3.02.42c-.93.13-1.63.36-2.1.7-.47.33-.71.91-.71,1.75,0,.61.22,1.11.65,1.5.44.38,1.02.57,1.75.57.99,0,1.81-.35,2.46-1.04.65-.7.98-1.59.98-2.65v-1.25Zm11.6,6.21c-.47.26-1.1.39-1.87.39-2.19,0-3.29-1.22-3.29-3.67v-7.41h-2.15v-1.71h2.15v-3.06l2-.65v3.7h3.15v1.71h-3.15v7.05c0,.84.14,1.44.43,1.8.29.36.76.54,1.42.54.51,0,.94-.14,1.31-.42v1.71Zm13.07.12h-2v-7.21c0-2.61-.97-3.91-2.91-3.91-.98,0-1.8.38-2.47,1.14-.67.75-1,1.72-1,2.9v7.09h-2v-18.53h2v8.09h.05c.96-1.58,2.33-2.37,4.11-2.37,2.82,0,4.23,1.7,4.23,5.1v7.71Z" />
				<path d="m309.17,576.77l-3.6,12.75h-1.75l-2.62-9.32c-.11-.4-.18-.83-.2-1.3h-.04c-.04.44-.11.87-.23,1.28l-2.64,9.33h-1.73l-3.73-12.75h1.64l2.71,9.78c.11.41.18.84.21,1.28h.04c.03-.31.12-.74.28-1.28l2.82-9.78h1.43l2.7,9.85c.09.34.17.73.21,1.19h.04c.02-.31.1-.72.24-1.23l2.6-9.81h1.62Zm8.03,12.75h-1.46v-1.42h-.04c-.63,1.09-1.57,1.64-2.8,1.64-.91,0-1.62-.24-2.13-.72-.51-.48-.76-1.12-.76-1.91,0-1.7,1-2.69,3-2.97l2.73-.38c0-1.55-.63-2.32-1.88-2.32-1.1,0-2.09.37-2.97,1.12v-1.49c.89-.57,1.93-.85,3.09-.85,2.14,0,3.21,1.13,3.21,3.4v5.92Zm-1.46-4.6l-2.2.3c-.68.09-1.19.26-1.53.51-.34.24-.52.66-.52,1.27,0,.44.16.81.47,1.09.32.28.74.42,1.27.42.72,0,1.32-.25,1.79-.76.47-.51.71-1.15.71-1.93v-.91Zm5.48,4.6h-1.46v-13.48h1.46v13.48Zm10.31,0h-2.04l-4.02-4.37h-.04v4.37h-1.46v-13.48h1.46v8.54h.04l3.82-4.17h1.91l-4.22,4.39,4.55,4.71Z" />
				<rect x="332.65" y="583.88" width="4.85" height="1.15" />
				<path d="m341.82,589.52h-1.49v-12.75h1.49v12.75Zm10.72,0h-1.46v-5.19c0-1.93-.71-2.9-2.12-2.9-.73,0-1.33.28-1.81.83-.47.55-.71,1.24-.71,2.07v5.19h-1.46v-9.1h1.46v1.51h.04c.69-1.15,1.68-1.72,2.99-1.72,1,0,1.76.32,2.28.97.53.64.79,1.57.79,2.78v5.56Z" />
				<path d="m308.57,613.27c-.94.5-2.12.75-3.52.75-1.81,0-3.27-.58-4.36-1.75-1.09-1.17-1.64-2.7-1.64-4.6,0-2.04.61-3.69,1.84-4.94,1.23-1.26,2.78-1.88,4.67-1.88,1.21,0,2.21.17,3,.52v1.59c-.91-.51-1.92-.76-3.02-.76-1.46,0-2.65.49-3.56,1.47-.91.98-1.36,2.28-1.36,3.92s.42,2.79,1.27,3.72c.85.92,1.97,1.38,3.35,1.38,1.28,0,2.39-.28,3.32-.85v1.45Zm3.86.53h-1.46v-13.48h1.46v13.48Zm6.76.21c-1.35,0-2.42-.42-3.23-1.27-.8-.85-1.2-1.98-1.2-3.39,0-1.53.42-2.72,1.25-3.58.84-.86,1.96-1.29,3.39-1.29s2.41.42,3.17,1.25c.76.84,1.15,1.99,1.15,3.48s-.41,2.62-1.24,3.49c-.82.87-1.92,1.31-3.3,1.31Zm.11-8.3c-.94,0-1.68.32-2.22.96-.55.63-.82,1.51-.82,2.63s.28,1.93.83,2.55c.55.62,1.29.93,2.21.93s1.67-.31,2.17-.92c.51-.61.76-1.48.76-2.6s-.25-2.01-.76-2.63c-.5-.62-1.23-.92-2.17-.92Zm6.21,7.76v-1.56c.79.59,1.67.88,2.62.88,1.28,0,1.92-.43,1.92-1.28,0-.24-.06-.45-.17-.61-.11-.17-.25-.32-.44-.45-.18-.13-.4-.25-.66-.35-.25-.11-.52-.22-.81-.33-.4-.16-.76-.32-1.07-.48-.3-.17-.56-.35-.76-.55-.2-.21-.36-.44-.46-.7-.1-.26-.15-.57-.15-.92,0-.43.1-.8.29-1.13.2-.33.46-.61.78-.83.33-.23.7-.39,1.11-.51.42-.11.85-.17,1.3-.17.79,0,1.49.14,2.12.41v1.48c-.67-.44-1.44-.66-2.31-.66-.27,0-.52.03-.74.1-.22.06-.41.15-.57.26-.15.11-.28.25-.36.41-.08.15-.12.33-.12.52,0,.24.04.44.12.6.09.16.22.3.38.43.17.12.37.24.6.34.24.1.51.21.81.33.4.15.76.31,1.08.48.32.16.59.34.82.55.23.2.4.44.52.7.12.27.19.58.19.95,0,.45-.1.84-.3,1.17-.2.33-.46.61-.79.83-.33.22-.71.38-1.15.49-.43.11-.89.16-1.36.16-.94,0-1.75-.18-2.44-.54Zm15.59-3.86h-6.43c.02,1.01.3,1.8.82,2.35s1.24.83,2.15.83c1.03,0,1.97-.34,2.83-1.01v1.37c-.8.58-1.86.87-3.17.87s-2.3-.41-3.03-1.24c-.73-.83-1.1-1.99-1.1-3.49,0-1.42.4-2.57,1.2-3.46.81-.89,1.8-1.34,3-1.34s2.11.39,2.76,1.16c.65.77.98,1.84.98,3.21v.76Zm-1.49-1.24c0-.84-.21-1.5-.61-1.96-.4-.47-.95-.7-1.66-.7s-1.27.25-1.75.74c-.48.49-.78,1.13-.89,1.93h4.92Zm7.93,5.33c-.34.19-.8.28-1.36.28-1.59,0-2.39-.89-2.39-2.67v-5.39h-1.56v-1.24h1.56v-2.22l1.46-.47v2.69h2.29v1.24h-2.29v5.13c0,.61.1,1.05.31,1.31.21.26.55.39,1.03.39.37,0,.68-.1.95-.3v1.24Z" />
				<path d="m550.66,839.42h-9.29v-17.53h8.9v1.86h-6.85v5.83h6.33v1.85h-6.33v6.14h7.24v1.86Zm13.52,0h-2v-7.14c0-2.66-.97-3.99-2.91-3.99-1,0-1.83.38-2.49,1.14-.65.75-.98,1.7-.98,2.85v7.14h-2v-12.52h2v2.08h.05c.95-1.58,2.31-2.37,4.11-2.37,1.37,0,2.42.44,3.14,1.33.73.88,1.09,2.16,1.09,3.83v7.65Zm9.61-.12c-.47.26-1.1.39-1.87.39-2.19,0-3.29-1.22-3.29-3.67v-7.41h-2.15v-1.71h2.15v-3.06l2-.65v3.7h3.15v1.71h-3.15v7.05c0,.84.14,1.44.43,1.8s.76.54,1.42.54c.51,0,.94-.14,1.31-.42v1.71Zm9.23-10.37c-.35-.27-.86-.4-1.52-.4-.86,0-1.57.4-2.15,1.21-.57.81-.86,1.91-.86,3.3v6.38h-2v-12.52h2v2.58h.05c.29-.88.72-1.56,1.31-2.05.59-.5,1.24-.75,1.97-.75.52,0,.92.06,1.2.17v2.08Zm12.17-2.03l-5.76,14.52c-1.03,2.59-2.47,3.89-4.33,3.89-.52,0-.96-.05-1.31-.16v-1.8c.43.15.83.22,1.19.22,1.01,0,1.77-.6,2.27-1.81l1-2.37-4.89-12.49h2.22l3.39,9.63c.04.12.13.44.26.95h.07c.04-.2.12-.51.24-.93l3.56-9.66h2.08Z" />
				<path d="m302.24,280.89v-17.53h4.99c1.52,0,2.72.37,3.61,1.11.89.74,1.33,1.71,1.33,2.9,0,.99-.27,1.86-.81,2.59-.54.73-1.28,1.26-2.22,1.56v.05c1.18.14,2.13.59,2.84,1.34.71.75,1.06,1.73,1.06,2.93,0,1.5-.54,2.71-1.61,3.64s-2.43,1.39-4.07,1.39h-5.11Zm2.05-15.67v5.66h2.1c1.12,0,2.01-.27,2.65-.81.64-.55.97-1.31.97-2.3,0-1.7-1.12-2.55-3.36-2.55h-2.36Zm0,7.51v6.31h2.79c1.21,0,2.14-.29,2.8-.86.67-.57,1-1.35,1-2.35,0-2.07-1.41-3.11-4.23-3.11h-2.36Zm22.07,2.41h-8.84c.03,1.39.41,2.47,1.12,3.23.72.76,1.7,1.14,2.96,1.14,1.41,0,2.71-.46,3.89-1.39v1.88c-1.1.8-2.55,1.2-4.36,1.2s-3.16-.57-4.17-1.7c-1.01-1.14-1.52-2.74-1.52-4.8,0-1.95.55-3.53,1.65-4.76,1.11-1.23,2.48-1.85,4.12-1.85s2.91.53,3.8,1.59,1.34,2.53,1.34,4.41v1.05Zm-2.05-1.7c0-1.16-.29-2.06-.84-2.7-.55-.64-1.31-.97-2.29-.97s-1.75.34-2.41,1.01c-.66.68-1.07,1.56-1.22,2.65h6.76Zm15.75,7.46h-2v-2.13h-.05c-.93,1.61-2.36,2.42-4.3,2.42-1.57,0-2.83-.56-3.78-1.67-.94-1.12-1.41-2.65-1.41-4.58,0-2.07.52-3.73,1.56-4.98s2.43-1.87,4.17-1.87,2.97.68,3.75,2.03h.05v-7.75h2v18.53Zm-2-5.66v-1.85c0-1.01-.33-1.87-1-2.57-.67-.7-1.52-1.05-2.54-1.05-1.22,0-2.18.45-2.88,1.34s-1.05,2.14-1.05,3.72c0,1.44.33,2.58,1,3.42.68.83,1.58,1.25,2.71,1.25s2.02-.4,2.71-1.21c.7-.81,1.05-1.83,1.05-3.06Zm12.58-4.83c-.35-.27-.86-.4-1.52-.4-.86,0-1.57.4-2.15,1.21-.57.81-.86,1.91-.86,3.3v6.38h-2v-12.52h2v2.58h.05c.29-.88.72-1.56,1.31-2.05.59-.5,1.24-.75,1.97-.75.52,0,.92.06,1.2.17v2.08Zm7.4,10.78c-1.85,0-3.33-.58-4.44-1.75-1.1-1.17-1.65-2.73-1.65-4.66,0-2.1.57-3.74,1.72-4.93,1.15-1.18,2.7-1.77,4.66-1.77s3.32.57,4.36,1.72c1.05,1.15,1.58,2.74,1.58,4.78s-.57,3.6-1.7,4.8c-1.12,1.2-2.64,1.8-4.54,1.8Zm.15-11.42c-1.29,0-2.31.44-3.06,1.32-.75.87-1.12,2.08-1.12,3.62s.38,2.65,1.14,3.51c.76.86,1.77,1.28,3.04,1.28s2.29-.42,2.98-1.26c.7-.84,1.05-2.03,1.05-3.58s-.35-2.77-1.05-3.62c-.69-.85-1.69-1.27-2.98-1.27Zm14.51,11.42c-1.85,0-3.33-.58-4.44-1.75-1.1-1.17-1.65-2.73-1.65-4.66,0-2.1.57-3.74,1.72-4.93,1.15-1.18,2.7-1.77,4.66-1.77s3.32.57,4.36,1.72c1.05,1.15,1.58,2.74,1.58,4.78s-.57,3.6-1.7,4.8c-1.12,1.2-2.64,1.8-4.54,1.8Zm.15-11.42c-1.29,0-2.31.44-3.06,1.32-.75.87-1.12,2.08-1.12,3.62s.38,2.65,1.14,3.51,1.77,1.28,3.04,1.28,2.29-.42,2.98-1.26c.7-.84,1.05-2.03,1.05-3.58s-.35-2.77-1.05-3.62c-.69-.85-1.69-1.27-2.98-1.27Zm27.05,11.12h-2v-7.19c0-1.39-.22-2.39-.65-3.01-.42-.62-1.14-.93-2.15-.93-.86,0-1.59.39-2.19,1.17-.59.78-.89,1.72-.89,2.81v7.14h-2v-7.43c0-2.46-.95-3.69-2.85-3.69-.88,0-1.61.37-2.18,1.11-.57.73-.86,1.69-.86,2.87v7.14h-2v-12.52h2v1.98h.05c.89-1.52,2.18-2.27,3.89-2.27.86,0,1.6.24,2.24.72.64.47,1.07,1.1,1.31,1.87.93-1.73,2.31-2.59,4.16-2.59,2.75,0,4.13,1.7,4.13,5.1v7.71Z" />
				<path d="m314.66,299.74c0,1.17-.12,2.21-.35,3.12-.23.91-.57,1.68-1.01,2.31-.44.63-.99,1.11-1.63,1.44-.64.33-1.37.49-2.19.49s-1.58-.15-2.22-.44v-1.4c.71.4,1.46.6,2.26.6.57,0,1.09-.12,1.54-.36.46-.24.84-.58,1.16-1.03.31-.46.55-1.02.72-1.68.17-.66.25-1.43.25-2.28h-.04c-.55,1.1-1.49,1.64-2.84,1.64-.55,0-1.05-.09-1.5-.28-.46-.2-.85-.47-1.18-.82-.33-.36-.59-.78-.77-1.26s-.28-1.02-.28-1.61c0-.63.1-1.2.3-1.72.21-.52.49-.97.85-1.34.37-.38.8-.67,1.3-.88.5-.21,1.05-.31,1.64-.31.64,0,1.21.13,1.7.39.5.25.92.63,1.25,1.13.34.49.6,1.1.77,1.82.18.72.27,1.55.27,2.48Zm-1.57-1.31c0-.49-.07-.94-.2-1.34-.12-.4-.3-.75-.52-1.03-.23-.29-.49-.51-.81-.67-.31-.16-.65-.24-1.01-.24s-.68.07-.98.21c-.3.14-.57.33-.79.59-.22.25-.39.55-.52.9-.12.34-.19.72-.19,1.13,0,.45.06.85.18,1.21.12.36.3.66.52.91.23.24.49.43.81.56.32.13.67.2,1.06.2.34,0,.65-.06.95-.19.3-.13.56-.3.78-.52.23-.22.4-.47.52-.76.13-.3.2-.61.2-.95Z" />
				<rect x="317.02" y="294.13" width="1.29" height="3.97" />
				<path d="m328.67,294.98c-.2.34-.43.76-.71,1.26-.27.5-.56,1.07-.87,1.7s-.62,1.3-.94,2.03c-.32.72-.62,1.47-.9,2.24-.28.77-.52,1.55-.74,2.35-.21.79-.36,1.56-.45,2.33h-1.56c.11-.76.27-1.53.49-2.32.23-.79.48-1.57.76-2.33.28-.76.58-1.5.9-2.2.31-.71.62-1.35.92-1.95s.57-1.11.81-1.56c.25-.46.45-.81.6-1.07h-6.39v-1.32h8.11v.84Z" />
				<path d="m332.27,294.13v3.97h-1.29v-3.97h1.29Zm2.95,0v3.97h-1.29v-3.97h1.29Z" />
				<path d="m349.8,297.78l-3.06,4.6,3,4.5h-1.7l-1.79-2.95c-.11-.18-.25-.41-.4-.69h-.04c-.03.05-.17.28-.42.69l-1.82,2.95h-1.68l3.1-4.46-2.97-4.64h1.7l1.76,3.11c.13.23.26.47.38.71h.04l2.28-3.82h1.61Z" />
				<path d="m361.46,306.88h-1.46v-11.01c-.11.11-.28.24-.5.39-.21.14-.46.28-.73.43-.27.14-.55.28-.85.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.01-.36.36-.15.71-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.57-.41.8-.6h.55v13.03Zm11.87-3.61c0,.57-.11,1.1-.33,1.57-.21.47-.52.87-.92,1.21-.39.33-.86.59-1.41.77s-1.16.28-1.82.28c-1.21,0-2.18-.23-2.9-.69v-1.56c.86.68,1.84,1.01,2.95,1.01.44,0,.84-.06,1.2-.17.36-.11.67-.28.92-.49.26-.21.46-.47.6-.77.14-.3.21-.64.21-1.02,0-1.67-1.19-2.5-3.56-2.5h-1.06v-1.24h1c2.1,0,3.15-.78,3.15-2.35,0-1.45-.8-2.17-2.4-2.17-.9,0-1.75.3-2.53.91v-1.41c.81-.49,1.78-.73,2.9-.73.53,0,1.02.07,1.45.22.43.15.8.36,1.11.62s.55.59.71.96c.17.37.26.79.26,1.24,0,1.68-.85,2.76-2.54,3.24v.04c.43.05.83.15,1.2.32.37.16.68.37.95.63.27.26.47.57.62.92.15.35.23.74.23,1.16Z" />
				<rect x="376.15" y="294.13" width="1.29" height="3.97" />
				<path d="m387.75,299.74c0,1.17-.12,2.21-.35,3.12-.23.91-.57,1.68-1.01,2.31-.44.63-.99,1.11-1.63,1.44-.64.33-1.37.49-2.19.49s-1.58-.15-2.22-.44v-1.4c.71.4,1.46.6,2.26.6.57,0,1.09-.12,1.54-.36.46-.24.84-.58,1.16-1.03.31-.46.55-1.02.72-1.68.17-.66.25-1.43.25-2.28h-.04c-.55,1.1-1.49,1.64-2.84,1.64-.55,0-1.05-.09-1.5-.28-.46-.2-.85-.47-1.18-.82-.33-.36-.59-.78-.77-1.26s-.28-1.02-.28-1.61c0-.63.1-1.2.3-1.72.21-.52.49-.97.85-1.34.37-.38.8-.67,1.3-.88.5-.21,1.05-.31,1.64-.31.64,0,1.21.13,1.7.39.5.25.92.63,1.25,1.13.34.49.6,1.1.77,1.82.18.72.27,1.55.27,2.48Zm-1.57-1.31c0-.49-.07-.94-.2-1.34-.12-.4-.3-.75-.52-1.03-.23-.29-.49-.51-.81-.67-.31-.16-.65-.24-1.01-.24s-.68.07-.98.21c-.3.14-.57.33-.79.59-.22.25-.39.55-.52.9-.12.34-.19.72-.19,1.13,0,.45.06.85.18,1.21.12.36.3.66.52.91.23.24.49.43.81.56.32.13.67.2,1.06.2.34,0,.65-.06.95-.19.3-.13.56-.3.78-.52.23-.22.4-.47.52-.76.13-.3.2-.61.2-.95Z" />
				<path d="m391.4,294.13v3.97h-1.29v-3.97h1.29Zm2.95,0v3.97h-1.29v-3.97h1.29Z" />
				<path d="m624.07,773.75h-2.86l-6.77-8.02c-.25-.3-.41-.51-.46-.61h-.05v8.63h-2.05v-17.53h2.05v8.24h.05c.11-.18.27-.38.46-.6l6.55-7.64h2.55l-7.52,8.41,8.04,9.12Zm3.07-15.7c-.36,0-.66-.12-.92-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.24.39.55.39.93s-.13.66-.39.92c-.25.25-.56.38-.93.38Zm.98,15.7h-2v-12.52h2v12.52Zm9.85-.12c-.47.26-1.1.39-1.87.39-2.19,0-3.29-1.22-3.29-3.67v-7.41h-2.15v-1.71h2.15v-3.06l2-.65v3.7h3.15v1.71h-3.15v7.05c0,.84.14,1.44.43,1.8s.76.54,1.42.54c.51,0,.94-.14,1.31-.42v1.71Zm11.2-.45c-.96.58-2.1.87-3.42.87-1.78,0-3.23-.58-4.33-1.74-1.09-1.17-1.64-2.67-1.64-4.52,0-2.06.59-3.72,1.77-4.96,1.18-1.25,2.76-1.88,4.73-1.88,1.1,0,2.07.2,2.91.61v2.05c-.93-.65-1.92-.98-2.98-.98-1.28,0-2.33.46-3.15,1.38-.81.91-1.22,2.11-1.22,3.61s.38,2.62,1.15,3.47c.77.85,1.81,1.27,3.11,1.27,1.09,0,2.12-.36,3.08-1.09v1.91Zm13.41.57h-2v-7.21c0-2.61-.97-3.91-2.91-3.91-.98,0-1.8.38-2.47,1.14-.67.75-1,1.72-1,2.9v7.09h-2v-18.53h2v8.09h.05c.96-1.58,2.33-2.37,4.11-2.37,2.82,0,4.23,1.7,4.23,5.1v7.71Zm13.83-5.76h-8.84c.03,1.39.41,2.47,1.12,3.23s1.7,1.14,2.96,1.14c1.41,0,2.71-.46,3.89-1.39v1.88c-1.1.8-2.55,1.2-4.36,1.2s-3.16-.57-4.17-1.7c-1.01-1.14-1.52-2.74-1.52-4.8,0-1.95.55-3.53,1.65-4.76,1.11-1.23,2.48-1.85,4.12-1.85s2.91.53,3.8,1.59c.9,1.06,1.34,2.53,1.34,4.41v1.05Zm-2.05-1.7c0-1.16-.29-2.06-.84-2.7-.55-.64-1.31-.97-2.29-.97s-1.75.34-2.41,1.01c-.66.68-1.07,1.56-1.22,2.65h6.76Zm15.46,7.46h-2v-7.14c0-2.66-.97-3.99-2.91-3.99-1,0-1.83.38-2.49,1.14-.65.75-.98,1.7-.98,2.85v7.14h-2v-12.52h2v2.08h.05c.95-1.58,2.31-2.37,4.11-2.37,1.37,0,2.42.44,3.14,1.33.73.88,1.09,2.16,1.09,3.83v7.65Z" />
				<path d="m546.14,277.48h-9.1v-17.53h2.05v15.67h7.04v1.86Zm3.45-15.7c-.36,0-.66-.12-.92-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.24.39.55.39.93s-.13.66-.39.92c-.25.25-.56.38-.93.38Zm.98,15.7h-2v-12.52h2v12.52Zm13.89-12.52l-4.99,12.52h-1.97l-4.74-12.52h2.2l3.18,9.1c.24.67.38,1.25.44,1.75h.05c.08-.63.21-1.19.39-1.7l3.33-9.14h2.11Zm3.17-3.18c-.36,0-.66-.12-.92-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.24.39.55.39.93s-.13.66-.39.92c-.25.25-.56.38-.93.38Zm.98,15.7h-2v-12.52h2v12.52Zm14.44,0h-2v-7.14c0-2.66-.97-3.99-2.91-3.99-1,0-1.83.38-2.49,1.14-.65.75-.98,1.7-.98,2.85v7.14h-2v-12.52h2v2.08h.05c.95-1.58,2.31-2.37,4.11-2.37,1.37,0,2.42.44,3.14,1.33.73.88,1.09,2.16,1.09,3.83v7.65Zm14.46-1c0,4.6-2.2,6.89-6.6,6.89-1.55,0-2.9-.29-4.06-.88v-2c1.41.78,2.75,1.17,4.03,1.17,3.08,0,4.62-1.64,4.62-4.91v-1.37h-.05c-.95,1.6-2.39,2.4-4.3,2.4-1.56,0-2.81-.55-3.77-1.66-.95-1.12-1.42-2.61-1.42-4.49,0-2.13.51-3.82,1.53-5.07,1.03-1.26,2.43-1.88,4.21-1.88s2.94.68,3.75,2.03h.05v-1.74h2v11.52Zm-2-4.66v-1.85c0-.99-.34-1.85-1.01-2.55-.67-.71-1.5-1.06-2.51-1.06-1.24,0-2.21.45-2.91,1.36-.7.9-1.05,2.16-1.05,3.78,0,1.39.33,2.51,1,3.35.68.83,1.57,1.25,2.68,1.25s2.04-.4,2.74-1.2c.71-.8,1.06-1.82,1.06-3.07Z" />
				<polygon points="609.46 259.95 601.05 280.39 599.18 280.39 607.57 259.95 609.46 259.95" />
				<path d="m611.5,277.48v-17.53h4.84c6.18,0,9.27,2.85,9.27,8.54,0,2.71-.86,4.88-2.58,6.53-1.71,1.64-4.01,2.46-6.88,2.46h-4.65Zm2.05-15.67v13.81h2.62c2.3,0,4.09-.62,5.37-1.85,1.28-1.23,1.92-2.97,1.92-5.23,0-4.49-2.39-6.74-7.16-6.74h-2.74Zm16.18-.02c-.36,0-.66-.12-.92-.37-.25-.24-.38-.55-.38-.93s.13-.68.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.24.39.55.39.93s-.13.66-.39.92c-.25.25-.56.38-.93.38Zm.98,15.7h-2v-12.52h2v12.52Zm14.37,0h-2v-7.14c0-2.66-.97-3.99-2.91-3.99-1,0-1.83.38-2.49,1.14-.65.75-.98,1.7-.98,2.85v7.14h-2v-12.52h2v2.08h.05c.95-1.58,2.31-2.37,4.11-2.37,1.37,0,2.42.44,3.14,1.33.73.88,1.09,2.16,1.09,3.83v7.65Zm4.73-15.7c-.36,0-.66-.12-.92-.37s-.38-.55-.38-.93.13-.68.38-.93c.25-.25.56-.38.92-.38s.68.13.93.38c.26.24.39.55.39.93s-.13.66-.39.92c-.25.25-.56.38-.93.38Zm.98,15.7h-2v-12.52h2v12.52Zm14.37,0h-2v-7.14c0-2.66-.97-3.99-2.91-3.99-1,0-1.83.38-2.49,1.14-.65.75-.98,1.7-.98,2.85v7.14h-2v-12.52h2v2.08h.05c.95-1.58,2.31-2.37,4.11-2.37,1.37,0,2.42.44,3.14,1.33.73.88,1.09,2.16,1.09,3.83v7.65Zm14.39-1c0,4.6-2.2,6.89-6.6,6.89-1.55,0-2.9-.29-4.06-.88v-2c1.41.78,2.75,1.17,4.03,1.17,3.08,0,4.62-1.64,4.62-4.91v-1.37h-.05c-.95,1.6-2.39,2.4-4.3,2.4-1.56,0-2.81-.55-3.77-1.66-.95-1.12-1.42-2.61-1.42-4.49,0-2.13.51-3.82,1.53-5.07,1.03-1.26,2.43-1.88,4.21-1.88s2.94.68,3.75,2.03h.05v-1.74h2v11.52Zm-2-4.66v-1.85c0-.99-.34-1.85-1.01-2.55-.67-.71-1.5-1.06-2.51-1.06-1.24,0-2.21.45-2.91,1.36-.7.9-1.05,2.16-1.05,3.78,0,1.39.33,2.51,1,3.35.68.83,1.57,1.25,2.68,1.25s2.04-.4,2.74-1.2c.71-.8,1.06-1.82,1.06-3.07Z" />
				<path d="m703.54,277.48h-2.44l-2.93-4.91c-.27-.46-.53-.84-.78-1.16-.25-.33-.51-.59-.78-.79-.26-.2-.55-.35-.86-.44-.3-.1-.64-.15-1.03-.15h-1.69v7.46h-2.05v-17.53h5.23c.77,0,1.47.1,2.11.29.65.19,1.21.48,1.69.87.48.39.86.88,1.12,1.47.27.58.4,1.26.4,2.04,0,.61-.09,1.17-.28,1.69-.18.51-.44.96-.78,1.36-.33.4-.74.74-1.22,1.03-.47.28-1.01.49-1.6.65v.05c.29.13.55.28.76.45.22.16.43.36.62.59s.39.49.57.78c.2.29.41.62.65,1l3.29,5.27Zm-10.51-15.67v6.36h2.79c.51,0,.99-.08,1.42-.23.44-.15.82-.37,1.14-.66.32-.29.57-.65.75-1.06.18-.42.27-.9.27-1.42,0-.94-.31-1.67-.92-2.19-.6-.53-1.48-.79-2.63-.79h-2.81Zm17.81,15.97c-1.85,0-3.33-.58-4.44-1.75-1.1-1.17-1.65-2.73-1.65-4.66,0-2.1.57-3.74,1.72-4.93,1.15-1.18,2.7-1.77,4.66-1.77s3.32.57,4.36,1.72c1.05,1.15,1.58,2.74,1.58,4.78s-.57,3.6-1.7,4.8c-1.12,1.2-2.64,1.8-4.54,1.8Zm.15-11.42c-1.29,0-2.31.44-3.06,1.32-.75.87-1.12,2.08-1.12,3.62s.38,2.65,1.14,3.51c.76.86,1.77,1.28,3.04,1.28s2.29-.42,2.98-1.26c.7-.84,1.05-2.03,1.05-3.58s-.35-2.77-1.05-3.62c-.69-.85-1.69-1.27-2.98-1.27Zm14.45,11.42c-1.85,0-3.33-.58-4.44-1.75-1.1-1.17-1.65-2.73-1.65-4.66,0-2.1.57-3.74,1.72-4.93,1.15-1.18,2.7-1.77,4.66-1.77s3.32.57,4.36,1.72c1.05,1.15,1.58,2.74,1.58,4.78s-.57,3.6-1.7,4.8c-1.12,1.2-2.64,1.8-4.54,1.8Zm.15-11.42c-1.29,0-2.31.44-3.06,1.32-.75.87-1.12,2.08-1.12,3.62s.38,2.65,1.14,3.51c.76.86,1.77,1.28,3.04,1.28s2.29-.42,2.98-1.26c.7-.84,1.05-2.03,1.05-3.58s-.35-2.77-1.05-3.62c-.69-.85-1.69-1.27-2.98-1.27Zm26.99,11.12h-2v-7.19c0-1.39-.22-2.39-.65-3.01-.42-.62-1.14-.93-2.15-.93-.86,0-1.59.39-2.19,1.17-.59.78-.89,1.72-.89,2.81v7.14h-2v-7.43c0-2.46-.95-3.69-2.85-3.69-.88,0-1.61.37-2.18,1.11-.57.73-.86,1.69-.86,2.87v7.14h-2v-12.52h2v1.98h.05c.89-1.52,2.18-2.27,3.89-2.27.86,0,1.6.24,2.24.72.64.47,1.07,1.1,1.31,1.87.93-1.73,2.31-2.59,4.16-2.59,2.75,0,4.13,1.7,4.13,5.1v7.71Z" />
				<path d="m608.23,296.34c0,1.17-.12,2.21-.35,3.12-.23.91-.57,1.68-1.01,2.31-.44.63-.99,1.11-1.63,1.44-.64.33-1.37.49-2.19.49s-1.58-.15-2.22-.44v-1.4c.71.4,1.46.6,2.26.6.57,0,1.09-.12,1.54-.36.46-.24.84-.58,1.16-1.03.31-.46.55-1.02.72-1.68.17-.66.25-1.43.25-2.28h-.04c-.55,1.1-1.49,1.64-2.84,1.64-.55,0-1.05-.09-1.5-.28-.46-.2-.85-.47-1.18-.82-.33-.36-.59-.78-.77-1.26s-.28-1.02-.28-1.61c0-.63.1-1.2.3-1.72.21-.52.49-.97.85-1.34.37-.38.8-.67,1.3-.88.5-.21,1.05-.31,1.64-.31.64,0,1.21.13,1.7.39.5.25.92.63,1.25,1.13.34.49.6,1.1.77,1.82.18.72.27,1.55.27,2.48Zm-1.57-1.31c0-.49-.07-.94-.2-1.34-.12-.4-.3-.75-.52-1.03-.23-.29-.49-.51-.81-.67-.31-.16-.65-.24-1.01-.24s-.68.07-.98.21c-.3.14-.57.33-.79.59-.22.25-.39.55-.52.9-.12.34-.19.72-.19,1.13,0,.45.06.85.18,1.21.12.36.3.66.52.91.23.24.49.43.81.56.32.13.67.2,1.06.2.34,0,.65-.06.95-.19.3-.13.56-.3.78-.52.23-.22.4-.47.52-.76.13-.3.2-.61.2-.95Z" />
				<rect x="610.59" y="290.73" width="1.29" height="3.97" />
				<path d="m614.07,299.92c0-.34.05-.68.16-1.01.11-.34.26-.66.45-.96.2-.3.45-.57.74-.81.3-.24.63-.44,1-.58-.55-.31-.99-.7-1.32-1.18-.33-.49-.49-1.02-.49-1.61,0-.47.09-.9.27-1.3.18-.4.44-.74.76-1.03.32-.29.7-.52,1.14-.68.44-.17.91-.25,1.42-.25s.99.08,1.43.25c.44.17.82.39,1.14.68.32.29.57.63.75,1.03s.27.83.27,1.29c0,.59-.16,1.12-.49,1.61-.33.48-.76.87-1.3,1.18.37.14.7.33.99.58s.53.51.73.81c.2.3.36.62.46.96.11.34.16.68.16,1.01,0,.56-.1,1.07-.3,1.53s-.49.86-.85,1.19c-.36.33-.8.58-1.31.76-.5.18-1.06.28-1.67.28s-1.16-.09-1.66-.28-.94-.44-1.31-.76c-.37-.33-.65-.73-.86-1.19-.2-.46-.3-.97-.3-1.53Zm1.58-.12c0,.4.06.76.18,1.08.12.32.3.59.52.82.23.23.49.4.81.52.32.12.67.18,1.06.18s.72-.06,1.03-.19c.31-.12.58-.3.81-.52.23-.23.41-.5.53-.82.13-.32.2-.68.2-1.07,0-.36-.06-.69-.19-1-.12-.31-.29-.59-.52-.83-.23-.24-.49-.42-.81-.56-.31-.14-.67-.2-1.06-.2-.37,0-.71.07-1.02.2-.31.12-.58.3-.81.53-.23.23-.4.5-.53.82-.13.31-.2.66-.2,1.04Zm.45-5.91c0,.3.05.58.16.84.11.25.26.48.45.68.2.19.42.34.68.45.25.11.53.16.82.16s.56-.06.82-.17c.26-.11.49-.26.68-.45.19-.2.34-.42.45-.68.11-.26.17-.54.17-.84s-.06-.59-.17-.85c-.11-.26-.25-.49-.44-.68-.19-.19-.41-.34-.68-.44-.25-.11-.53-.17-.83-.17-.31,0-.6.06-.86.17-.25.11-.48.27-.67.46-.18.19-.33.41-.43.68-.1.26-.15.54-.15.84Z" />
				<path d="m625.84,290.73v3.97h-1.29v-3.97h1.29Zm2.95,0v3.97h-1.29v-3.97h1.29Z" />
				<path d="m643.37,294.37l-3.06,4.6,3,4.5h-1.7l-1.79-2.95c-.11-.18-.25-.41-.4-.69h-.04c-.03.05-.17.28-.42.69l-1.82,2.95h-1.68l3.1-4.46-2.97-4.64h1.7l1.76,3.11c.13.23.26.47.38.71h.04l2.28-3.82h1.61Z" />
				<path d="m655.03,303.47h-1.46v-11.01c-.11.11-.28.24-.5.39-.21.14-.46.28-.73.43-.27.14-.55.28-.85.4-.3.12-.59.22-.87.29v-1.48c.32-.09.66-.21,1.01-.36.36-.15.71-.32,1.06-.51.35-.19.68-.39.99-.59.31-.21.57-.41.8-.6h.55v13.03Zm11.87-3.61c0,.57-.11,1.1-.33,1.57-.21.47-.52.87-.92,1.21-.39.33-.86.59-1.41.77s-1.16.28-1.82.28c-1.21,0-2.18-.23-2.9-.69v-1.56c.86.68,1.84,1.01,2.95,1.01.44,0,.84-.06,1.2-.17.36-.11.67-.28.92-.49.26-.21.46-.47.6-.77.14-.3.21-.64.21-1.02,0-1.67-1.19-2.5-3.56-2.5h-1.06v-1.24h1c2.1,0,3.15-.78,3.15-2.35,0-1.45-.8-2.17-2.4-2.17-.9,0-1.75.3-2.53.91v-1.41c.81-.49,1.78-.73,2.9-.73.53,0,1.02.07,1.45.22.43.15.8.36,1.11.62.31.27.55.59.71.96.17.37.26.79.26,1.24,0,1.68-.85,2.76-2.54,3.24v.04c.43.05.83.15,1.2.32.37.16.68.37.95.63.27.26.47.57.62.92.15.35.23.74.23,1.16Z" />
				<rect x="669.72" y="290.73" width="1.29" height="3.97" />
				<path d="m679.95,290.73v8.42h1.64v1.33h-1.64v3h-1.44v-3h-5.99v-1.26c.56-.63,1.12-1.3,1.69-2.01.57-.72,1.11-1.44,1.63-2.18.52-.73,1-1.47,1.44-2.2.44-.73.82-1.44,1.12-2.11h1.56Zm-5.79,8.42h4.35v-6.24c-.44.78-.87,1.47-1.26,2.08-.4.61-.78,1.16-1.14,1.66-.36.5-.7.95-1.02,1.35s-.63.79-.92,1.15Z" />
				<path d="m684.97,290.73v3.97h-1.29v-3.97h1.29Zm2.95,0v3.97h-1.29v-3.97h1.29Z" />
				<path d="m756.13,520.28l-2.88,10.21h-1.4l-2.1-7.46c-.09-.32-.14-.66-.16-1.04h-.03c-.03.35-.09.69-.19,1.03l-2.11,7.48h-1.39l-2.99-10.21h1.32l2.17,7.83c.09.33.15.67.17,1.03h.04c.02-.25.1-.59.22-1.03l2.26-7.83h1.15l2.16,7.89c.08.27.13.59.17.95h.03c.02-.25.08-.57.19-.98l2.09-7.86h1.3Z" />
				<polygon points="762.09 520.28 757.19 532.18 756.1 532.18 760.98 520.28 762.09 520.28" />
				<path d="m763.27,530.49v-10.21h2.82c3.6,0,5.4,1.66,5.4,4.98,0,1.58-.5,2.84-1.5,3.8-1,.95-2.33,1.43-4.01,1.43h-2.71Zm1.2-9.13v8.05h1.52c1.34,0,2.38-.36,3.13-1.08.75-.72,1.12-1.73,1.12-3.05,0-2.62-1.39-3.92-4.17-3.92h-1.59Z" />
			</g>
		</g>
	)
}

export default PlanD
